import ceoImg from "../../assets/temporary-images/aboutus/ceo.png";
import newYorkImg from "../../assets/temporary-images/location-new-york.png";
import middleEastImg from "../../assets/temporary-images/location-middle-east.png";
import europeImg from "../../assets/temporary-images/location-europe.png";
import certificationImg from "../../assets/temporary-images/legal.svg";
import transcribeImg from "../../assets/temporary-images/transcribe.svg";
import aboutusBanner from "../../assets/temporary-images/aboutus/banner.svg";
import ourStoryImg from "../../assets/temporary-images/aboutus/our-story.svg";
import agencyImg from "../../assets/temporary-images/aboutus/agency.svg";
import contactUsPopUpBanner from "../../assets/temporary-images/legal-transcription-popup-banner.png";
import securityBanner from "../../assets/temporary-images/security-confidentiality/banner.svg";
import lawEnforcementBanner from "../../assets/temporary-images/banner/law-enforcement.svg";
import pillarBanner from "../../assets/temporary-images/banner/pillar.svg";
import whyImg1 from "../../assets/temporary-images/why-1.png";
import whyImg2 from "../../assets/temporary-images/why-2.svg";
import whyImg3 from "../../assets/temporary-images/why-3.png";
import arbitrationBanner from "../../assets/temporary-images/banner/arbitration.svg";
import courtBanner from "../../assets/temporary-images/banner/court.svg";

export const legalTranscriptionHeaderdata = {
  logoIcon: "legal-transcription-logo",
  logoText: {
    default: "legal transcription",
    en: "legal transcription",
    fr: "",
  },
  navList: [
    {
      id: 1,
      link: null,
      text: {
        default: "Services",
        en: "Services",
        fr: "Services",
      },
      subLink: [
        {
          link: "/deposition-transcription",
          text: {
            default: "Deposition Transcription",
            en: "Deposition Transcription",
            fr: "Deposition Transcription",
          },
        },
        {
          link: "/arbitration-transcription",
          text: {
            default: "Arbitration Transcription",
            en: "Arbitration Transcription",
            fr: "Arbitration Transcription",
          },
        },
        {
          link: "/court-transcription",
          text: {
            default: "Court Transcription",
            en: "Court Transcription",
            fr: "Court Transcription",
          },
        },
        {
          link: "/law-enforcement-transcription",
          text: {
            default: "Law Enforcement Transcription",
            en: "Law Enforcement Transcription",
            fr: "Law Enforcement Transcription",
          },
        },
        {
          link: "/medico-legal-transcription",
          text: {
            default: "Medico Legal Transcription",
            en: "Medico Legal Transcription",
            fr: "Medico Legal Transcription",
          },
        },
        {
          link: "/certified-transcription",
          text: {
            default: "Certified Transcription",
            en: "Certified Transcription",
            fr: "Certified Transcription",
          },
        },
        {
          link: "/transcript-proofreading",
          text: {
            default: "Transcript Proofreading",
            en: "Transcript Proofreading",
            fr: "Transcript Proofreading",
          },
        },
        {
          link: "/verbatim-transcription",
          text: {
            default: "Verbatim Transcription",
            en: "Verbatim Transcription",
            fr: "Verbatim Transcription",
          },
        },
        {
          link: "/rush-transcription",
          text: {
            default: "Rush Transcription",
            en: "Rush Transcription",
            fr: "Rush Transcription",
          },
        },
      ],
    },
    {
      id: 2,
      link: null,
      text: {
        default: "Company",
        en: "Company",
        fr: "Company",
      },
      subLink: [
        {
          link: "/about-us",
          text: {
            default: "About Us",
            en: "About Us",
            fr: "About Us",
          },
        },
      ],
    },
    {
      id: 3,
      link: "/contactus",
      text: {
        default: "Contact Us",
        en: "Contact Us",
        fr: "Contact Us",
      },
    },
  ],
};

export const bannerData = {
  title: {
    default: "Legal Transcription Services",
    en: "Legal Transcription Services",
    fr: "Legal Transcription Services",
  },
  description: {
    default:
      "LexTranscribe is one of the leading legal transcription companies in the US. We offer expert transcription services to top law firms, legal institutions, and businesses in every state. We guarantee accuracy and fast delivery while maintaining your confidentiality. Let our experienced transcriptionists streamline your process, saving your money and, most importantly—time.",
    en: "LexTranscribe is one of the leading legal transcription companies in the US. We offer expert transcription services to top law firms, legal institutions, and businesses in every state. We guarantee accuracy and fast delivery while maintaining your confidentiality. Let our experienced transcriptionists streamline your process, saving your money and, most importantly—time.",
    fr: "LexTranscribe is one of the leading legal transcription companies in the US. We offer expert transcription services to top law firms, legal institutions, and businesses in every state. We guarantee accuracy and fast delivery while maintaining your confidentiality. Let our experienced transcriptionists streamline your process, saving your money and, most importantly—time.",
  },
  btnText: {
    default: "GET STARTED",
    en: "GET STARTED",
    fr: "GET STARTED",
  },
  imgurl: {
    default:
      "https://tomedes.gumlet.io/assets/legal-transcription/banner/banner.webp",
    en: "https://tomedes.gumlet.io/assets/legal-transcription/banner/banner.webp",
    fr: "https://tomedes.gumlet.io/assets/legal-transcription/banner/banner.webp",
  },
  sealDesktop: [
    {
      icon: "quality-guaranteed",
      text: "Guaranteed</br>Quality & Accuracy",
    },
    {
      icon: "expert-human",
      text: "Expert Human</br>Transcriptionists",
    },
    {
      icon: "fast-delivery-two",
      text: "Fast Delivery",
    },
    {
      icon: "secure",
      text: "Secure &</br>Confidential",
    },
  ],
  sealMobile: [
    {
      icon: "expert-human",
      text: "Expert Human</br>Transcriptionists",
    },
    {
      icon: "rating",
      text: "4.8 out of 5</br>Aggregate Rating",
    },
  ],
};

export const certificationSampleData = {
  imgurl: {
    default: certificationImg,
    en: certificationImg,
    fr: certificationImg,
  },
  title: {
    default:
      "Specialized<br> legal transcription with 99% accuracy only from LexTranscribe",
    en: "Specialized<br> legal transcription with 99% accuracy only from LexTranscribe",
    fr: "Specialized<br> legal transcription with 99% accuracy only from LexTranscribe",
  },
  highlightWords: {
    default: ["LexTranscribe"],
    en: ["LexTranscribe"],
    fr: ["LexTranscribe"],
  },
  highlightedColor: "yellow",
  description: {
    default:
      "Our legal transcriptionists specialize in many different areas from criminal defense to property law. With years of experience transcribing for law firms and businesses of all sizes, we guarantee the highest level of quality and accuracy.",
    en: "Our legal transcriptionists specialize in many different areas from criminal defense to property law. With years of experience transcribing for law firms and businesses of all sizes, we guarantee the highest level of quality and accuracy.",
    fr: "Our legal transcriptionists specialize in many different areas from criminal defense to property law. With years of experience transcribing for law firms and businesses of all sizes, we guarantee the highest level of quality and accuracy.",
  },
};

export const Uspdata = {
  imgurl: {
    default: transcribeImg,
    en: transcribeImg,
    fr: transcribeImg,
  },
  title: {
    default: "Transcribe Your Legal Files In Three Simple Steps",
    en: "Transcribe Your Legal Files In Three Simple Steps",
    fr: "Transcribe Your Legal Files In Three Simple Steps",
  },
  description: {
    default:
      "1. Send your files over our secure network.<br>2. Pay online.<br>3. Receive your transcripts.",
    en: "1. Send your files over our secure network.<br>2. Pay online.<br>3. Receive your transcripts.",
    fr: "1. Send your files over our secure network.",
  },
  icon: "lock-white",
  securityText: {
    default: "Security, Privacy and Confidentiality Guarantee",
    en: "Security, Privacy and Confidentiality Guarantee",
    fr: "Security, Privacy and Confidentiality Guarantee",
  },
  securityText2: {
    default: "Your information is protected by 256-bit SSL encryption.",
    en: "Your information is protected by 256-bit SSL encryption.",
    fr: "Your information is protected by 256-bit SSL encryption.",
  },
  cta: {
    text: {
      default: "GET STARTED TODAY",
      en: "GET STARTED TODAY",
      fr: "GET STARTED TODAY",
    },
    href: "/contactus",
  },
};

export const twoColGridNewData = {
  title: {
    default: "Industry Leaders Rely On Legal Transcription Company",
    en: "Industry Leaders Rely On Legal Transcription Company",
    fr: "Industry Leaders Rely On Legal Transcription Company",
  },
  highlightWords: {
    default: [" "],
    en: [" "],
    fr: [" "],
  },
  highlightedColor: "yellow",
  subTitle: {
    default:
      "Professionals embrace legal transcription in a variety of industries, from real estate to law. If you’re tired of sifting through endless files for valuable information, Legal Transcription Company has the solution.",
    en: "Professionals embrace legal transcription in a variety of industries, from real estate to law. If you’re tired of sifting through endless files for valuable information, Legal Transcription Company has the solution.",
    fr: "Professionals embrace legal transcription in a variety of industries, from real estate to law. If you’re tired of sifting through endless files for valuable information, Legal Transcription Company has the solution.",
  },
  items: [
    {
      image: {
        default:
          "https://tomedes.gumlet.io/assets/legal-transcription/section-4/img-1.webp",
        en: "https://tomedes.gumlet.io/assets/legal-transcription/section-4/img-1.webp",
        fr: "https://tomedes.gumlet.io/assets/legal-transcription/section-4/img-1.webp",
      },

      heading: {
        default:
          "Tired Of Wasting Your Law Firm’s Valuable Resources On Futile Tasks?",
        en: "Tired Of Wasting Your Law Firm’s Valuable Resources On Futile Tasks?",
        fr: "Tired Of Wasting Your Law Firm’s Valuable Resources On Futile Tasks?",
      },
      as: "p",
      highlightWords: {
        default: ["Delivery"],
        en: ["Delivery"],
        fr: ["Sed"],
      },
      highlightedColor: "yellow",
      paragraphs: [
        {
          text: {
            default:
              "Make researching and referencing effortless with searchable legal transcripts. Simply press Ctrl + F, type a keyword into the search box, and each instance of the phrase is highlighted for you. Our legal transcription services virtually pay for themselves with the administrative costs and time you save.",
            en: "Make researching and referencing effortless with searchable legal transcripts. Simply press Ctrl + F, type a keyword into the search box, and each instance of the phrase is highlighted for you. Our legal transcription services virtually pay for themselves with the administrative costs and time you save.",
            fr: "Make researching and referencing effortless with searchable legal transcripts. Simply press Ctrl + F, type a keyword into the search box, and each instance of the phrase is highlighted for you. Our legal transcription services virtually pay for themselves with the administrative costs and time you save.",
          },
          highlightWords: {
            default: [" "],
            en: [" "],
            fr: [" "],
          },
          highlightedColor: "yellow",
        },
      ],
    },
    {
      image: {
        default:
          "https://tomedes.gumlet.io/assets/legal-transcription/section-4/img-2.webp",
        en: "https://tomedes.gumlet.io/assets/legal-transcription/section-4/img-2.webp",
        fr: "https://tomedes.gumlet.io/assets/legal-transcription/section-4/img-2.webp",
      },

      heading: {
        default:
          "Struggling To Meet Deadlines Imposed By Clients Or The Court?",
        en: "Struggling To Meet Deadlines Imposed By Clients Or The Court?",
        fr: "Struggling To Meet Deadlines Imposed By Clients Or The Court?",
      },
      as: "p",
      highlightWords: {
        default: ["Delivery"],
        en: ["Delivery"],
        fr: [" "],
      },
      highlightedColor: "yellow",
      paragraphs: [
        {
          text: {
            default:
              "We understand you face time-sensitive matters. Our accurate legal transcriptionists provide fast turnaround times without sacrificing quality or accuracy. We’ll ensure your transcripts are formatted according to your requirements. So you can meet the client's demands and concentrate on winning your case.",
            en: "We understand you face time-sensitive matters. Our accurate legal transcriptionists provide fast turnaround times without sacrificing quality or accuracy. We’ll ensure your transcripts are formatted according to your requirements. So you can meet the client's demands and concentrate on winning your case.",
            fr: "We understand you face time-sensitive matters. Our accurate legal transcriptionists provide fast turnaround times without sacrificing quality or accuracy. We’ll ensure your transcripts are formatted according to your requirements. So you can meet the client's demands and concentrate on winning your case.",
          },
          highlightWords: {
            default: [" "],
            en: [" "],
            fr: [" "],
          },
          highlightedColor: "yellow",
        },
      ],
    },
    {
      image: {
        default:
          "https://tomedes.gumlet.io/assets/legal-transcription/section-4/img-3.webp",
        en: "https://tomedes.gumlet.io/assets/legal-transcription/section-4/img-3.webp",
        fr: "https://tomedes.gumlet.io/assets/legal-transcription/section-4/img-3.webp",
      },

      heading: {
        default: "Drowning In Corporate Paperwork?",
        en: "Drowning In Corporate Paperwork?",
        fr: "Drowning In Corporate Paperwork?",
      },
      as: "p",
      highlightWords: {
        default: ["Delivery"],
        en: ["Delivery"],
        fr: ["Sed"],
      },
      highlightedColor: "yellow",
      paragraphs: [
        {
          text: {
            default:
              "When audio and video files pile up, it’s challenging to find the information you need. Whether you’re from real estate or a corporate legal department, we can combine your legal documents into convenient digital files and take the pressure off of your business. Our native human translators provide error-free legal transcription services to streamline your workflow.",
            en: "When audio and video files pile up, it’s challenging to find the information you need. Whether you’re from real estate or a corporate legal department, we can combine your legal documents into convenient digital files and take the pressure off of your business. Our native human translators provide error-free legal transcription services to streamline your workflow.",
            fr: "When audio and video files pile up, it’s challenging to find the information you need. Whether you’re from real estate or a corporate legal department, we can combine your legal documents into convenient digital files and take the pressure off of your business. Our native human translators provide error-free legal transcription services to streamline your workflow.",
          },
          highlightWords: {
            default: [" "],
            en: [" "],
            fr: [" "],
          },
          highlightedColor: "yellow",
        },
      ],
    },
    {
      image: {
        default:
          "https://tomedes.gumlet.io/assets/legal-transcription/section-4/img-4.webp",
        en: "https://tomedes.gumlet.io/assets/legal-transcription/section-4/img-4.webp",
        fr: "https://tomedes.gumlet.io/assets/legal-transcription/section-4/img-4.webp",
      },

      heading: {
        default: "Suffering Burnout From Tedious Law Enforcement Tasks?",
        en: "Suffering Burnout From Tedious Law Enforcement Tasks?",
        fr: "Suffering Burnout From Tedious Law Enforcement Tasks?",
      },
      as: "p",
      highlightWords: {
        default: ["Delivery"],
        en: ["Delivery"],
        fr: ["Sed"],
      },
      highlightedColor: "yellow",
      paragraphs: [
        {
          text: {
            default:
              "Transcribing victim or suspect statements is a monotonous task, and more than likely, it is not what you dreamed of doing as an investigator or police officer. With our dependable legal transcription services, you can focus on protecting your community. Let our experts take care of your tedious work.",
            en: "Transcribing victim or suspect statements is a monotonous task, and more than likely, it is not what you dreamed of doing as an investigator or police officer. With our dependable legal transcription services, you can focus on protecting your community. Let our experts take care of your tedious work.",
            fr: "Transcribing victim or suspect statements is a monotonous task, and more than likely, it is not what you dreamed of doing as an investigator or police officer. With our dependable legal transcription services, you can focus on protecting your community. Let our experts take care of your tedious work.",
          },
          highlightWords: {
            default: [" "],
            en: [" "],
            fr: [" "],
          },
          highlightedColor: "yellow",
        },
      ],
    },
  ],
};
export const enquiryFormData = {
  title: {
    default: "Add english translation",
    en: "Add english translation",
    fr: "Parlez-nous de vous et de votre projet",
  },
  highlightWords: {
    default: ["english"],
    en: ["english"],
    fr: ["Parlez-nous"],
  },
  highlightedColor: "yellow",
  subtitle: {
    default: "Add english translation",
    en: "Add english translation",
    fr: "Envoyez-nous un message avec vos coordonnées, nous revenons vers vous en moins de 30 minutes.",
  },

  placeholder: {
    name: {
      default: "Name",
      en: "Name",
      fr: "Nom complet",
    },
    email: {
      default: "Email Address",
      en: "Email Address",
      fr: "Adresse e-mail",
    },
    message: {
      default: "Tell us more about your needs",
      en: "Tell us more about your needs",
      fr: "En quoi pouvons-nous vous aider ?",
    },
  },

  fieldRequired: {
    default: "This field is required",
    en: "This field is required",
    fr: "Ce champ est obligatoire",
  },

  submitButtonText: {
    default: "SUBMIT",
    en: "SUBMIT",
    fr: "ENVOYER",
  },
};
export const ctaWithFormData = {
  title: {
    default: "Get Your Free Legal Transcription Quote Today.",
    en: "Get Your Free Legal Transcription Quote Today.",
    fr: "Get Your Free Legal Transcription Quote Today.",
  },
  subtitle: {
    default: "*By submitting, you agree to LexTranscribe's Privacy Policy.",
    en: "*By submitting, you agree to LexTranscribe's Privacy Policy.",
    fr: "*By submitting, you agree to LexTranscribe's Privacy Policy.",
  },
  placeholder: {
    name: {
      default: "Name",
      en: "Name",
      fr: "Name",
    },
    email: {
      default: "Email Address",
      en: "Email Address",
      fr: "Email Address",
    },
  },
  btnText: {
    default: "SUBMIT",
    en: "SUBMIT",
    fr: "SUBMIT",
  },
};

export const onsidedata = {
  title: {
    default: "Custom Legal Transcription in the United States",
    en: "Custom Legal Transcription in the United States",
    fr: "Custom Legal Transcription in the United States",
  },
  highlightWords: {
    default: ["Legal Transcription"],
    en: ["Legal Transcription"],
    fr: ["Legal Transcription"],
  },
  highlightedColor: "yellow",
  description: {
    default:
      "Say goodbye to long delays. Get fast, accurate deposition transcripts near you when you need them. Our deposition transcriptionists have extensive experience in US laws and regulations. Get certified deposition transcripts in major US cities from Beverly Hills to New York.",
    en: "We offer legal transcription services in every US state from New York City to California. Whether you need medico-legal, law enforcement or court transcripts, we're here to help.<br /><br /> Outsource legal transcription with LexTranscribe and connect with native legal transcriptionists in the US who specialize in your area of the law.",
    fr: "We offer legal transcription services in every US state from New York City to California. Whether you need medico-legal, law enforcement or court transcripts, we're here to help.<br /><br />Outsource legal transcription with LexTranscribe and connect with native legal transcriptionists in the US who specialize in your area of the law.",
  },
};

export const LegalTranscriptionServiceClientsData = {
  title: {
    default:
      "Discover Why Law Firms and Legal Institutions Worldwide Trust Legal Transcription Company",
    en: "Discover Why Law Firms and Legal Institutions Worldwide Trust Legal Transcription Company",
    fr: "Discover Why Law Firms and Legal Institutions Worldwide Trust Legal Transcription Company",
  },

  highlightWords: {
    default: ["Trust"],
    en: ["Trust"],
    fr: ["Trust"],
  },
  highlightedColor: "yellow",
  subtitle: {
    default:
      "We implement the highest security and quality standards. That’s how world-renowned institutions trust us.",
    en: "We implement the highest security and quality standards. That’s how world-renowned institutions trust us.",
    fr: "We implement the highest security and quality standards. That’s why world-renowned institutions trust us!",
  },

  clients: [
    {
      id: 1,
      title: {
        default: "Amazon",
        en: "Amazon",
        fr: "Add french translation",
      },
      icon: "amazon",
      className: "w-24 h-auto",
    },
    {
      id: 2,
      title: {
        default: "Google",
        en: "Google",
        fr: "Add french translation",
      },
      icon: "google",
      className: "w-20 h-auto",
    },
    {
      id: 3,
      title: {
        default: "Microsoft",
        en: "Microsoft",
        fr: "Add french translation",
      },
      icon: "microsoft",
      className: "w-24 h-auto",
    },
    {
      id: 4,
      title: {
        default: "Youtube",
        en: "Youtube",
        fr: "Add french translation",
      },
      icon: "youtube",
      className: "w-24 h-auto",
    },
    {
      id: 5,
      title: {
        default: "Bloomberg",
        en: "Bloomberg",
        fr: "Add french translation",
      },
      icon: "bloomberg",
      className: "w-24 h-auto",
    },
    {
      id: 6,
      title: {
        default: "Spotify",
        en: "Spotify",
        fr: "Add french translation",
      },
      icon: "spotify",
      className: "w-20 h-auto",
    },
    {
      id: 7,
      title: {
        default: "Wix",
        en: "Wix",
        fr: "Add french translation",
      },
      icon: "wix",
      className: "w-20 h-auto",
    },
    {
      id: 8,
      title: {
        default: "HSBC",
        en: "HSBC",
        fr: "Add french translation",
      },
      icon: "hsbc",
      className: "w-24 h-auto",
    },
    {
      id: 9,
      title: {
        default: "Canon",
        en: "Canon",
        fr: "Add french translation",
      },
      icon: "canon",
      className: "w-24 h-auto",
    },
    {
      id: 10,
      title: {
        default: "MGM",
        en: "MGM",
        fr: "Add french translation",
      },
      icon: "mgm",
      className: "w-11 h-auto",
    },
    {
      id: 11,
      title: {
        default: "Code",
        en: "Code",
        fr: "Add french translation",
      },
      icon: "code",
      className: "w-9 h-auto",
    },
    {
      id: 12,
      title: {
        default: "SAP",
        en: "SAP",
        fr: "Add french translation",
      },
      icon: "sap",
      className: "w-12 h-auto",
    },
  ],
};

export const legalContactus = {
  title: {
    default: "Let’s Work Together",
    en: "Let’s Work Together",
    fr: "Let’s Work Together",
  },
  highlightWords: {
    default: [""],
    en: [""],
    fr: [""],
  },
  highlightedColor: "yellow",
  subtitle: {
    default:
      "Ready to simplify your workflow? Questions or concerns? Get immediate assistance by filling out the contact form below. We welcome your feedback as well. You can also contact us on <span class='text-yellow'>+1 985 239 0142</span> or <span class='text-yellow'>+44 (0)16 1509 6140</span>.",
    en: "Ready to simplify your workflow? Questions or concerns? Get immediate assistance by filling out the contact form below. We welcome your feedback as well. You can also contact us on <span class='text-yellow'>+1 985 239 0142</span> or <span class='text-yellow'>+44 (0)16 1509 6140</span>.",
    fr: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut.",
  },

  placeholder: {
    firstName: {
      default: "First Name",
      en: "First Name",
      fr: "",
      labelText: {
        default: "First Name<span class='text-red'>*</span>",
        en: "First Name<span class='text-red'>*</span>",
        fr: "First Name<span class='text-red'>*</span>",
      },
    },
    lastName: {
      default: "Last Name",
      en: "Last Name",
      fr: "",
      labelText: {
        default: "Last Name<span class='text-red'>*</span>",
        en: "Last Name<span class='text-red'>*</span>",
        fr: "Last Name<span class='text-red'>*</span>",
      },
    },
    email: {
      default: "Email Address",
      en: "Email Address",
      fr: "Email Address",
      labelText: {
        default: "Email address<span class='text-red'>*</span>",
        en: "Email address<span class='text-red'>*</span>",
        fr: "Email address<span class='text-red'>*</span>",
      },
    },
    phoneNumber: {
      default: "Phone number",
      en: "Phone number",
      fr: "",
      labelText: {
        default: "Phone number",
        en: "Phone number",
        fr: "Phone number",
      },
    },
    company: {
      default: "Company",
      en: "Company",
      fr: "company",
      labelText: {
        default: "Company",
        en: "Company",
        fr: "company",
      },
    },
    message: {
      default: "Tell us more about your needs",
      en: "Tell us more about your needs",
      fr: "En quoi pouvons-nous vous aider ?",
      labelText: {
        default: "Message",
        en: "Message",
        fr: "Message",
      },
    },
  },

  fieldRequired: {
    default: "This field is required",
    en: "This field is required",
    fr: "Ce champ est obligatoire",
  },

  submitButtonText: {
    default: "SUBMIT",
    en: "SUBMIT",
    fr: "ENVOYER",
  },
};

export const DoubleColTwoData = {
  title: {
    default: "Expert Legal Transcription Services—100% Quality Guaranteed",
    en: "Expert Legal Transcription Services—100% Quality Guaranteed",
    fr: "Expert Legal Transcription Services—100% Quality Guaranteed",
  },
  highlightWords: {
    default: ["100% Quality Guaranteed"],
    en: ["100% Quality Guaranteed"],
    fr: ["100% Quality Guaranteed"],
  },
  highlightedColor: "yellow",
  subtitle: {
    default:
      "Our human transcribers provide accurate legal transcriptions for your law firm, business, or personal use. We specialize in a variety of transcription services, guaranteeing 100% quality and giving you access to the information you need when it’s most important.",
    en: "Our human transcribers provide accurate legal transcriptions for your law firm, business, or personal use. We specialize in a variety of transcription services, guaranteeing 100% quality and giving you access to the information you need when it’s most important.",
    fr: "Our human transcribers provide accurate legal transcriptions for your law firm, business, or personal use. We specialize in a variety of transcription services, guaranteeing 100% quality and giving you access to the information you need when it’s most important.",
  },
  maindata: [
    {
      id: 1,
      icon: "arbitration",
      heading: {
        default: "Arbitration",
        en: "Arbitration",
        fr: "Arbitration",
      },
      maintext: {
        default:
          "Don’t waste hours scanning notes. Receive a verbatim account of who said what with exact timestamps. Make your remote and in-person hearings efficient with precise arbitration transcription.",
        en: "Don’t waste hours scanning notes. Receive a verbatim account of who said what with exact timestamps. Make your remote and in-person hearings efficient with precise arbitration transcription.",
        fr: "Don’t waste hours scanning notes. Receive a verbatim account of who said what with exact timestamps. Make your remote and in-person hearings efficient with precise arbitration transcription.",
      },
      cta: {
        text: {
          default:
            "Discover how arbitration transcription eliminates the confusion of who says what and when",
          en: "Discover how arbitration transcription eliminates the confusion of who says what and when",
          fr: "Discover how arbitration transcription eliminates the confusion of who says what and when",
        },
        href: {
          default: "/arbitration-transcription",
          en: "/arbitration-transcription",
          fr: "/arbitration-transcription",
        },
      },
    },
    {
      id: 2,
      icon: "deposition",
      heading: {
        default: "Deposition",
        en: "Deposition",
        fr: "Deposition",
      },
      maintext: {
        default:
          "Out-of-court depositions place a heavy burden on your legal team. Our experts provide reliable deposition transcription services. Save time and energy so you can focus on strategy.",
        en: "Out-of-court depositions place a heavy burden on your legal team. Our experts provide reliable deposition transcription services. Save time and energy so you can focus on strategy.",
        fr: "Out-of-court depositions place a heavy burden on your legal team. Our experts provide reliable deposition transcription services. Save time and energy so you can focus on strategy.",
      },
      cta: {
        text: {
          default:
            "Find out how deposition transcription makes your workflow more efficient",
          en: "Find out how deposition transcription makes your workflow more efficient",
          fr: "Find out how deposition transcription makes your workflow more efficient",
        },
        href: {
          default: "/deposition-transcription",
          en: "/deposition-transcription",
          fr: "/deposition-transcription",
        },
      },
    },
    {
      id: 3,
      icon: "court",
      heading: {
        default: "Court",
        en: "Court",
        fr: "Court",
      },
      maintext: {
        default:
          "Don’t miss important details. We have extensive experience with the US court system. Trust our team to deliver accurate court transcripts on your schedule. Strengthen your case with the facts.",
        en: "Don’t miss important details. We have extensive experience with the US court system. Trust our team to deliver accurate court transcripts on your schedule. Strengthen your case with the facts.",
        fr: "Don’t miss important details. We have extensive experience with the US court system. Trust our team to deliver accurate court transcripts on your schedule. Strengthen your case with the facts.",
      },
      cta: {
        text: {
          default:
            "Interested? Learn how law firms and businesses use court transcription to increase productivity",
          en: "Interested? Learn how law firms and businesses use court transcription to increase productivity",
          fr: "Interested? Learn how law firms and businesses use court transcription to increase productivity",
        },
        href: {
          default: "/court-transcription",
          en: "/court-transcription",
          fr: "/court-transcription",
        },
      },
    },
    {
      id: 4,
      icon: "law-enforcement",
      heading: {
        default: "Law Enforcement",
        en: "Law Enforcement",
        fr: "Law Enforcement",
      },
      maintext: {
        default:
          "You don’t have to endure the painstaking task of law enforcement transcription. Legal Transcription Company understands your heavy caseload. Get witness and victim statements transcribed in just three easy steps.",
        en: "You don’t have to endure the painstaking task of law enforcement transcription. LexTranscribe understands your heavy caseload. Get witness and victim statements transcribed in just three easy steps.",
        fr: "You don’t have to endure the painstaking task of law enforcement transcription. LexTranscribe understands your heavy caseload. Get witness and victim statements transcribed in just three easy steps.",
      },
      cta: {
        text: {
          default:
            "Curious? Check out the ways law enforcement transcription eases your department’s workload",
          en: "Curious? Check out the ways law enforcement transcription eases your department’s workload",
          fr: "Curious? Check out the ways law enforcement transcription eases your department’s workload",
        },
        href: {
          default: "/law-enforcement-transcription",
          en: "/law-enforcement-transcription",
          fr: "/law-enforcement-transcription",
        },
      },
    },
  ],
};
export const aboutctaWithFormData2 = {
  title: {
    default:
      "Increase your productivity with a team who cares about your success.",
    en: "Increase your productivity with a team who cares about your success.",
    fr: "Increase your productivity with a team who cares about your success.",
  },
  subtitle: {
    default: "*By submitting, you agree to LexTranscribe's Privacy Policy.",
    en: "*By submitting, you agree to LexTranscribe's Privacy Policy.",
    fr: "*By submitting, you agree to LexTranscribe's Privacy Policy.",
  },
  placeholder: {
    name: {
      default: "Name",
      en: "Name",
      fr: "Name",
    },
    email: {
      default: "Email Address",
      en: "Email Address",
      fr: "Email Address",
    },
  },
  btnText: {
    default: "SUBMIT",
    en: "SUBMIT",
    fr: "SUBMIT",
  },
};
export const ctaWithFormData2 = {
  title: {
    default: "Save money and time with fast, accurate legal transcription.",
    en: "Save money and time with fast, accurate legal transcription.",
    fr: "Save money and time with fast, accurate legal transcription.",
  },
  subtitle: {
    default: "*By submitting, you agree to LexTranscribe's Privacy Policy.",
    en: "*By submitting, you agree to LexTranscribe's Privacy Policy.",
    fr: "*By submitting, you agree to LexTranscribe's Privacy Policy.",
  },
  placeholder: {
    name: {
      default: "Name",
      en: "Name",
      fr: "Name",
    },
    email: {
      default: "Email Address",
      en: "Email Address",
      fr: "Email Address",
    },
  },
  btnText: {
    default: "SUBMIT",
    en: "SUBMIT",
    fr: "SUBMIT",
  },
};

export const SecuirtyctaWithFormData2 = {
  title: {
    default: "Get access to secure legal transcription today.",
    en: "Get access to secure legal transcription today.",
    fr: "Get access to secure legal transcription today.",
  },
  subtitle: {
    default: "*By submitting, you agree to LexTranscribe's Privacy Policy.",
    en: "*By submitting, you agree to LexTranscribe's Privacy Policy.",
    fr: "*By submitting, you agree to LexTranscribe's Privacy Policy.",
  },
  placeholder: {
    name: {
      default: "Name",
      en: "Name",
      fr: "Name",
    },
    email: {
      default: "Email Address",
      en: "Email Address",
      fr: "Email Address",
    },
  },
  btnText: {
    default: "SUBMIT",
    en: "SUBMIT",
    fr: "SUBMIT",
  },
};
export const legalTranscriptionFooterData = {
  title: {
    default: "© Copyright 2022 LexTranscribe. All Rights Reserved.",
    en: "© Copyright 2022 LexTranscribe. All Rights Reserved.",
    fr: "© Copyright 2022 LexTranscribe. All Rights Reserved.",
  },
};

export const contactusPopupData = {
  title: {
    default: "Contact Us",
    en: "Contact Us",
    fr: "Contact Us",
  },
  description: {
    default:
      "Enter your details and we will get back to you within a few minutes.",
    en: "Enter your details and we will get back to you within a few minutes.",
    fr: "Enter your details and we will get back to you within a few minutes.",
  },
  highlightWords: {
    default: [],
    en: [],
    fr: [],
  },
  highlightedColor: "yellow",
  label1: {
    default: "Name",
    en: "Name",
    fr: "Name",
  },
  label2: {
    default: "Email address",
    en: "Email address",
    fr: "Email address",
  },
  label3: {
    default: "Tell us about your needs",
    en: "Tell us about your needs",
    fr: "Tell us about your needs",
  },
  userAgreement: {
    default: "*By submitting this, you agree to LexTranscribe’s ",
    en: "*By submitting this, you agree to LexTranscribe’s ",
    fr: "*By submitting this, you agree to LexTranscribe’s ",
  },
  userAgreementCta: {
    text: {
      default: "Privacy Policy.",
      en: "Privacy Policy.",
      fr: "Privacy Policy.",
    },
    link: "/",
  },
  star: "*",
  fieldRequired: {
    default: "This field is required",
    en: "This field is required",
    fr: "This field is required",
  },
  btnText: {
    default: "SUBMIT",
    en: "SUBMIT",
    fr: "SUBMIT",
  },
  image: {
    default: contactUsPopUpBanner,
    en: contactUsPopUpBanner,
    fr: contactUsPopUpBanner,
  },
};
export const thankYouPopUpData = {
  title: {
    default: "Thank You!",
    en: "Thank You!",
    fr: "Thank You!",
  },
  message: {
    default:
      "Your message was sent successfully. We will get back to you within a few minutes.",
    en: "Your message was sent successfully. We will get back to you within a few minutes.",
    fr: "Your message was sent successfully. We will get back to you within a few minutes.",
  },
  btnText: {
    default: "OK",
    en: "OK",
    fr: "OK",
  },
};
export const termscondtionData = {
  title: {
    default: "Terms and Conditions",
    en: "Terms and Conditions",
    fr: "Terms and Conditions",
  },
  subTitle: {
    default: "STANDARD USER AGREEMENT",
    en: "STANDARD USER AGREEMENT",
    fr: "STANDARD USER AGREEMENT",
  },
  subTitlePara: {
    default:
      "This document is a legal agreement between you,the 'User' (as defined below) and Tomedes.These User's Terms and Conditions ('Agreemen') sets forth the provisions under which the User may register and use the web-site for the purpose of responding to solicitations for the acquisition of solutions,services, and products ,providing these solutions, services, and products and taking care of requested revisions of the software solutions,services, and products.<br /> <br />DEFINITIONS Site (s): Tomedes Ltd: (if applicable) is the parent company and owner of the site hereinafter referred to as Tomedes.User: Individual (s) or a Company posting a project. <br /> <br /> Provider: Individual (s) or a Company providing a service.",
  },
  listData: [
    {
      id: 1,
      heading: {
        default: " 1. TERM",
        en: " 1. TERM",
        fr: " 1. TERM",
      },
      paraText: {
        default:
          "The initial term of this Agreement shall be a period of one (1) year from the Effective Date. Thereafter, the Agreement shall automatically renew for subsequent one (1) year terms. At any time, either party may terminate this agreement, with or without cause, upon thirty (30) days prior written notice. Tomedes reserves the right to immediately terminate any User who commits fraud, slander, a denial-of-service attack, or commits any other action which it deems inappropriate. Neither party has made any commitments regarding the duration or renewal of this Agreement beyond those stated herein.",
        en: "The initial term of this Agreement shall be a period of one (1) year from the Effective Date. Thereafter, the Agreement shall automatically renew for subsequent one (1) year terms. At any time, either party may terminate this agreement, with or without cause, upon thirty (30) days prior written notice. Tomedes reserves the right to immediately terminate any User who commits fraud, slander, a denial-of-service attack, or commits any other action which it deems inappropriate. Neither party has made any commitments regarding the duration or renewal of this Agreement beyond those stated herein.",
        fr: "The initial term of this Agreement shall be a period of one (1) year from the Effective Date. Thereafter, the Agreement shall automatically renew for subsequent one (1) year terms. At any time, either party may terminate this agreement, with or without cause, upon thirty (30) days prior written notice. Tomedes reserves the right to immediately terminate any User who commits fraud, slander, a denial-of-service attack, or commits any other action which it deems inappropriate. Neither party has made any commitments regarding the duration or renewal of this Agreement beyond those stated herein.",
      },
    },
    {
      id: 2,
      heading: {
        default: "2. SCOPE",
        en: "2. SCOPE",
        fr: "2. SCOPE",
      },
      paraText: {
        default:
          "You may be able to request information on our sites regarding products and Services, including technical support and customer Service, by using online forms. We may ask that you provide certain contact information to allow us to fulfill your request and to send you information about Tomedes products and Services.",
        en: "You may be able to request information on our sites regarding products and Services, including technical support and customer Service, by using online forms. We may ask that you provide certain contact information to allow us to fulfill your request and to send you information about Tomedes products and Services.",
        fr: "You may be able to request information on our sites regarding products and Services, including technical support and customer Service, by using online forms. We may ask that you provide certain contact information to allow us to fulfill your request and to send you information about Tomedes products and Services.",
      },
    },
    {
      id: 3,
      heading: {
        default: "3. User's OBLIGATIONS",
        en: "3. User's OBLIGATIONS",
        fr: "3. User's OBLIGATIONS",
      },
      paraText: {
        default:
          "The User will post a translation request, including all relevant information and/or documents in relation with his request. The User will process payment as requested by Tomedes before starting the translation process. 4.<br/><br/> This Agreement shall govern the business relationship between Tomedes and User despite any different or conflicting terms and conditions in User's forms or other documents.",
        en: "The User will post a translation request, including all relevant information and/or documents in relation with his request. The User will process payment as requested by Tomedes before starting the translation process. 4.<br/><br/> This Agreement shall govern the business relationship between Tomedes and User despite any different or conflicting terms and conditions in User's forms or other documents.",
        fr: "The User will post a translation request, including all relevant information and/or documents in relation with his request. The User will process payment as requested by Tomedes before starting the translation process. 4.<br/><br/> This Agreement shall govern the business relationship between Tomedes and User despite any different or conflicting terms and conditions in User's forms or other documents.",
      },
    },
    {
      id: 4,
      heading: {
        default: "4.1 GENERAL",
        en: "4.1. GENERAL",
        fr: "4.1. GENERAL",
      },
      paraText: {
        default:
          "o The User authorizes Tomedes to treat any person using User's password pair (username and password), and any resulting transactions, obligations and liabilities as if User used the website and/or services itself.<br/><br/> o User must nottry to expose the identity of other Users or of Providers. The identity of Providers and of other Users is not visible to the Users. The User must not post any information which may reveal his identity to Providers or other Users. Posting contact information including but not limited to phone #s, email addresses, Internet URL's, Yahoo Messenger Ids, ICQ ids is strictly prohibited.",
        en: "o The User authorizes Tomedes to treat any person using User's password pair (username and password), and any resulting transactions, obligations and liabilities as if User used the website and/or services itself.<br/><br/> o User must nottry to expose the identity of other Users or of Providers. The identity of Providers and of other Users is not visible to the Users. The User must not post any information which may reveal his identity to Providers or other Users. Posting contact information including but not limited to phone #s, email addresses, Internet URL's, Yahoo Messenger Ids, ICQ ids is strictly prohibited.",
        fr: "o The User authorizes Tomedes to treat any person using User's password pair (username and password), and any resulting transactions, obligations and liabilities as if User used the website and/or services itself.<br/><br/> o User must nottry to expose the identity of other Users or of Providers. The identity of Providers and of other Users is not visible to the Users. The User must not post any information which may reveal his identity to Providers or other Users. Posting contact information including but not limited to phone #s, email addresses, Internet URL's, Yahoo Messenger Ids, ICQ ids is strictly prohibited.",
      },
    },
    {
      id: 5,
      heading: {
        default: "4.2. REGISTRATION",
        en: "4.2. REGISTRATION",
        fr: "4.2. REGISTRATION",
      },
      paraText: {
        default:
          "o User's information shall be true, accurate and up-to-date at all times.",
        en: "o User's information shall be true, accurate and up-to-date at all times.",
        fr: "o User's information shall be true, accurate and up-to-date at all times.",
      },
    },
    {
      id: 6,
      heading: {
        default: "4.3. PAYMENT",
        en: "4.3. PAYMENT",
        fr: "4.3. PAYMENT",
      },
      paraText: {
        default:
          "o Payment will be processed by the User prior to commencing the translation process. Missing or incomplete payment will cause a delay in starting and therefore a delay in delivering the completed translation. <br/><br/>o The User is the only responsible party for a delay caused by the above reason.<br/><br/><span class='font-medium'> Violators of any of these terms can have all of their Tomedes accounts terminated, suspended or revoked at the discretion of Tomedes.</span>",
        en: "o Payment will be processed by the User prior to commencing the translation process. Missing or incomplete payment will cause a delay in starting and therefore a delay in delivering the completed translation. <br/><br/>o The User is the only responsible party for a delay caused by the above reason.<br/><br/><span class='font-medium'> Violators of any of these terms can have all of their Tomedes accounts terminated, suspended or revoked at the discretion of Tomedes.</span>",
        fr: "o Payment will be processed by the User prior to commencing the translation process. Missing or incomplete payment will cause a delay in starting and therefore a delay in delivering the completed translation. <br/><br/>o The User is the only responsible party for a delay caused by the above reason.<br/><br/><span class='font-medium'> Violators of any of these terms can have all of their Tomedes accounts terminated, suspended or revoked at the discretion of Tomedes.</span>",
      },
    },
    {
      id: 7,
      heading: {
        default: "5. REFUND/CANCELLATION POLICY",
        en: "5. REFUND/CANCELLATION POLICY",
        fr: "5. REFUND/CANCELLATION POLICY",
      },
      paraText: {
        default:
          "1. Any cancellation request after an order has been processed must be submitted in writing to the following email address: support@tomedes.com <br/><br/>2. If the company has not yet started the translation a full cancellation and refund will be granted. Should the translation already be in process, it will be stopped at the earliest opportunity (taking possible time zone hour differences into consideration). The client will only be charged for the part of the translation which has been completed. <br/><br/>3. Our goal is to provide a service of exceptional quality at a great value. For this reason, we offer a 1 year guarantee on all of our language services. Should you have any concern or are not satisfied with the final product, please contact our customer service at 'email' or 'phone Nr.' Our translator will review the translation according to the client’s comments and offer feedback. Any agreed upon errors will be edited at no extra charge to the client. In certain cases, where we fail to meet an agreement with the client, a partial or full refund may be offered.",
        en: "1. Any cancellation request after an order has been processed must be submitted in writing to the following email address: support@tomedes.com <br/><br/>2. If the company has not yet started the translation a full cancellation and refund will be granted. Should the translation already be in process, it will be stopped at the earliest opportunity (taking possible time zone hour differences into consideration). The client will only be charged for the part of the translation which has been completed. <br/><br/>3. Our goal is to provide a service of exceptional quality at a great value. For this reason, we offer a 1 year guarantee on all of our language services. Should you have any concern or are not satisfied with the final product, please contact our customer service at 'email' or 'phone Nr.' Our translator will review the translation according to the client’s comments and offer feedback. Any agreed upon errors will be edited at no extra charge to the client. In certain cases, where we fail to meet an agreement with the client, a partial or full refund may be offered.",
        fr: "1. Any cancellation request after an order has been processed must be submitted in writing to the following email address: support@tomedes.com <br/><br/>2. If the company has not yet started the translation a full cancellation and refund will be granted. Should the translation already be in process, it will be stopped at the earliest opportunity (taking possible time zone hour differences into consideration). The client will only be charged for the part of the translation which has been completed. <br/><br/>3. Our goal is to provide a service of exceptional quality at a great value. For this reason, we offer a 1 year guarantee on all of our language services. Should you have any concern or are not satisfied with the final product, please contact our customer service at 'email' or 'phone Nr.' Our translator will review the translation according to the client’s comments and offer feedback. Any agreed upon errors will be edited at no extra charge to the client. In certain cases, where we fail to meet an agreement with the client, a partial or full refund may be offered.",
      },
    },
    {
      id: 8,
      heading: {
        default: "6. USER'S REPRESENTATIONS.",
        en: "6. USER'S REPRESENTATIONS.",
        fr: "6. USER'S REPRESENTATIONS.",
      },
      paraText: {
        default:
          "User represents that it has the full power and authority to execute this Agreement. User is the owner of, and/or has received all appropriate consent from the owners of, any and all material, information, intellectual property in any form, or other data that User makes available to Tomedes.",
        en: "User represents that it has the full power and authority to execute this Agreement. User is the owner of, and/or has received all appropriate consent from the owners of, any and all material, information, intellectual property in any form, or other data that User makes available to Tomedes.",
        fr: "User represents that it has the full power and authority to execute this Agreement. User is the owner of, and/or has received all appropriate consent from the owners of, any and all material, information, intellectual property in any form, or other data that User makes available to Tomedes.",
      },
    },
    {
      id: 9,
      heading: {
        default: "7. TAXES",
        en: "7. TAXES",
        fr: "7. TAXES",
      },
      paraText: {
        default:
          "Tomedes does not collect taxes, duties, fees or other governmentally imposed excises, so User and Provider agree to assume their respective responsibilities under the law",
        en: "Tomedes does not collect taxes, duties, fees or other governmentally imposed excises, so User and Provider agree to assume their respective responsibilities under the law",
        fr: "Tomedes does not collect taxes, duties, fees or other governmentally imposed excises, so User and Provider agree to assume their respective responsibilities under the law",
      },
    },
    {
      id: 10,
      heading: {
        default: "8. TRADEMARKS AND CONFIDENTIAL INFORMATION.",
        en: "8. TRADEMARKS AND CONFIDENTIAL INFORMATION.",
        fr: "8. TRADEMARKS AND CONFIDENTIAL INFORMATION.",
      },
      paraText: {
        default:
          "Any information the User disclosed to the providers is considered confidential unless indicated otherwise<br/><br/> Return of Confidential Information. In any event of termination or expiration of this Agreement, each party will, within five (5) business days, return to the other party such party's Confidential Information.",
        en: "Any information the User disclosed to the providers is considered confidential unless indicated otherwise<br/><br/> Return of Confidential Information. In any event of termination or expiration of this Agreement, each party will, within five (5) business days, return to the other party such party's Confidential Information.",
        fr: "Any information the User disclosed to the providers is considered confidential unless indicated otherwise<br/><br/> Return of Confidential Information. In any event of termination or expiration of this Agreement, each party will, within five (5) business days, return to the other party such party's Confidential Information.",
      },
    },
    {
      id: 11,
      heading: {
        default: "9. INTELLECTUAL PROPERTY INFRINGEMENT INDEMNITY",
        en: "9. INTELLECTUAL PROPERTY INFRINGEMENT INDEMNITY",
        fr: "9. INTELLECTUAL PROPERTY INFRINGEMENT INDEMNITY",
      },
      paraText: {
        default:
          "Infringement Claims. The Provider will defend and hold Tomedes harmless in any suit or proceeding based on a claim that any equipment, products or services transacted under this Agreement, constitutes infringement of any copyright, patent or trademark. Provider will pay all settlements or damages awarded against Tomedes, provided that Tomedes (i) informs Provider of such suit or proceeding in writing and within thirty (30) days of actual notice of a claim, and provides Provider with all related information, (ii) grants Provider the authority to settle or litigate such suit or proceeding, and (iii) provides all necessary assistance to Provider.",
        en: "Infringement Claims. The Provider will defend and hold Tomedes harmless in any suit or proceeding based on a claim that any equipment, products or services transacted under this Agreement, constitutes infringement of any copyright, patent or trademark. Provider will pay all settlements or damages awarded against Tomedes, provided that Tomedes (i) informs Provider of such suit or proceeding in writing and within thirty (30) days of actual notice of a claim, and provides Provider with all related information, (ii) grants Provider the authority to settle or litigate such suit or proceeding, and (iii) provides all necessary assistance to Provider.",
        fr: "Infringement Claims. The Provider will defend and hold Tomedes harmless in any suit or proceeding based on a claim that any equipment, products or services transacted under this Agreement, constitutes infringement of any copyright, patent or trademark. Provider will pay all settlements or damages awarded against Tomedes, provided that Tomedes (i) informs Provider of such suit or proceeding in writing and within thirty (30) days of actual notice of a claim, and provides Provider with all related information, (ii) grants Provider the authority to settle or litigate such suit or proceeding, and (iii) provides all necessary assistance to Provider.",
      },
    },
    {
      id: 12,
      heading: {
        default: "10. LIMITATION OF LIABILITY; INDEMNITY.",
        en: "10. LIMITATION OF LIABILITY; INDEMNITY.",
        fr: "10. LIMITATION OF LIABILITY; INDEMNITY.",
      },
      paraText: {
        default:
          "IN NO EVENT SHALL TOMEDES BE LIABLE TO BUYERS, PROVIDERS OR ANY OTHER PERSON FOR EXEMPLARY, INCIDENTAL, INDIRECT, SPECIAL OR CONSEQUENTIAL DAMAGES OF ANY KIND, INCLUDING WITHOUT LIMITATION THE COST OF COVER, LOSS OF PROFIT, USE, SAVINGS OR REVENUE, OR THE CLAIMS OF THIRD PARTIES, WHETHER OR NOT TOMEDES HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH LOSS. THE LIMITATIONS IN THIS SECTION SHALL APPLY NOTWITHSTANDING THE FAILURE OF ESSENTIAL PURPOSE OF ANY LIMITED REMEDY.<br/<br/><br/> <span class='font-medium'>Indemnification by Provider.</span> Provider shall indemnify, defend (with counsel approved in writing by Tomedes) and hold Tomedes, its officers, directors, shareholders, employees, insurers, attorneys, successors and assigns harmless against any and all claims for cost, damage, expense (including reasonable attorneys - fees) or liability arising out of or related to the acts or omissions of Provider, its employees, representatives or agents.",
        en: "IN NO EVENT SHALL TOMEDES BE LIABLE TO BUYERS, PROVIDERS OR ANY OTHER PERSON FOR EXEMPLARY, INCIDENTAL, INDIRECT, SPECIAL OR CONSEQUENTIAL DAMAGES OF ANY KIND, INCLUDING WITHOUT LIMITATION THE COST OF COVER, LOSS OF PROFIT, USE, SAVINGS OR REVENUE, OR THE CLAIMS OF THIRD PARTIES, WHETHER OR NOT TOMEDES HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH LOSS. THE LIMITATIONS IN THIS SECTION SHALL APPLY NOTWITHSTANDING THE FAILURE OF ESSENTIAL PURPOSE OF ANY LIMITED REMEDY.<br/<br/><br/> <span class='font-medium'>Indemnification by Provider.</span> Provider shall indemnify, defend (with counsel approved in writing by Tomedes) and hold Tomedes, its officers, directors, shareholders, employees, insurers, attorneys, successors and assigns harmless against any and all claims for cost, damage, expense (including reasonable attorneys - fees) or liability arising out of or related to the acts or omissions of Provider, its employees, representatives or agents.",
        fr: "IN NO EVENT SHALL TOMEDES BE LIABLE TO BUYERS, PROVIDERS OR ANY OTHER PERSON FOR EXEMPLARY, INCIDENTAL, INDIRECT, SPECIAL OR CONSEQUENTIAL DAMAGES OF ANY KIND, INCLUDING WITHOUT LIMITATION THE COST OF COVER, LOSS OF PROFIT, USE, SAVINGS OR REVENUE, OR THE CLAIMS OF THIRD PARTIES, WHETHER OR NOT TOMEDES HAS BEEN ADVISED OF THE POSSIBILITY OF SUCH LOSS. THE LIMITATIONS IN THIS SECTION SHALL APPLY NOTWITHSTANDING THE FAILURE OF ESSENTIAL PURPOSE OF ANY LIMITED REMEDY.<br/<br/><br/> <span class='font-medium'>Indemnification by Provider.</span> Provider shall indemnify, defend (with counsel approved in writing by Tomedes) and hold Tomedes, its officers, directors, shareholders, employees, insurers, attorneys, successors and assigns harmless against any and all claims for cost, damage, expense (including reasonable attorneys - fees) or liability arising out of or related to the acts or omissions of Provider, its employees, representatives or agents.",
      },
    },
    {
      id: 13,
      heading: {
        default: "11. DEFAULT AND TERMINATION.",
        en: "11. DEFAULT AND TERMINATION.",
        fr: "11. DEFAULT AND TERMINATION.",
      },
      paraText: {
        default:
          "Default. Should the User default, their account may be terminated by Tomedes. User shall be considered to have defaulted under the Agreement for any failure to perform its obligations and/or if Tomedes discovers any material misrepresentation or omission that User has made in this Agreement or its Registration. In the case of either party, the failure by such party to observe or perform any material covenant or obligation under this Agreement shall constitute default. User may also be considered in default if they violate the site terms of service.. <br/><br/>Survival. The parties' obligations under Sections 6, 7 and 8 shall survive any termination and/or expiration of this Agreement.",
        en: "Default. Should the User default, their account may be terminated by Tomedes. User shall be considered to have defaulted under the Agreement for any failure to perform its obligations and/or if Tomedes discovers any material misrepresentation or omission that User has made in this Agreement or its Registration. In the case of either party, the failure by such party to observe or perform any material covenant or obligation under this Agreement shall constitute default. User may also be considered in default if they violate the site terms of service.. <br/><br/>Survival. The parties' obligations under Sections 6, 7 and 8 shall survive any termination and/or expiration of this Agreement.",
        fr: "Default. Should the User default, their account may be terminated by Tomedes. User shall be considered to have defaulted under the Agreement for any failure to perform its obligations and/or if Tomedes discovers any material misrepresentation or omission that User has made in this Agreement or its Registration. In the case of either party, the failure by such party to observe or perform any material covenant or obligation under this Agreement shall constitute default. User may also be considered in default if they violate the site terms of service.. <br/><br/>Survival. The parties' obligations under Sections 6, 7 and 8 shall survive any termination and/or expiration of this Agreement.",
      },
    },
    {
      id: 14,
      heading: {
        default: "12. GENERAL.",
        en: "12. GENERAL.",
        fr: "12. GENERAL.",
      },
      paraText: {
        default:
          "Assignment. User shall not assign or transfer this Agreement without Tomedes's prior written consent, which shall not be unreasonably withheld. Any attempted assignment shall be null and void. Relationship of the Parties. This Agreement does not create a franchise, joint venture or partnership between the parties. Neither party hereunder is the agent, broker, partner, employee, or legal representative of the other for any purpose. Excused Performance. Neither party shall be liable for failure to perform its obligations under this Agreement for causes beyond its reasonable control. No Waiver. The failure of either party to enforce any of the provisions hereof shall not be construed to be a waiver of the right of such party to thereafter enforce any such provision.<br/><br/> Unenforceable Provisions. If any term of this Agreement is found to be illegal or unenforceable, the remaining portions of this Agreement shall remain in effect, provided that the parties agree to negotiate in good faith substitute enforceable terms.<br/><br/> Modifications; Special Agreements; Entire Agreement. Note that Tomedes reserves the right from time to time to amend, modify or change this agreement. Due to the majority of parties requesting not to be contacted via email about updates to the site, email notice will not always be given. Additionally, due to the financial costs associated with written notices...written notice will not always be given. If you are interested in keeping abreast of the latest changes to this agreement, then please bookmark this page and review it from time to time.<br/><br/> IF ANY MODIFICATION IS UNACCEPTABLE TO YOU, YOUR ONLY RECOURSE IS TO TERMINATE THIS AGREEMENT BY PROVIDING NOTICE TO US. YOUR CONTINUED PARTICIPATION IN THE PROGRAM FOLLOWING OUR POSTING OF A CHANGE NOTICE OR NEW AGREEMENT ON OUR SITE WILL CONSTITUTE BINDING ACCEPTANCE OF THE CHANGE.<br/><br/> Should Tomedes and the User come to a special understanding not outlined in this agreement it will be laid out in writing and signed by both parties.<br/><br/> This Agreement is the entire understanding between User and Tomedes with respect to the subject matter of this Agreement, and supersedes all (i) proposals, oral or written, (ii) negotiations, conversations or discussions between the parties and (iii) industry custom or past course of dealing, relating to the subject matter.",
        en: "Assignment. User shall not assign or transfer this Agreement without Tomedes's prior written consent, which shall not be unreasonably withheld. Any attempted assignment shall be null and void. Relationship of the Parties. This Agreement does not create a franchise, joint venture or partnership between the parties. Neither party hereunder is the agent, broker, partner, employee, or legal representative of the other for any purpose. Excused Performance. Neither party shall be liable for failure to perform its obligations under this Agreement for causes beyond its reasonable control. No Waiver. The failure of either party to enforce any of the provisions hereof shall not be construed to be a waiver of the right of such party to thereafter enforce any such provision.<br/><br/> Unenforceable Provisions. If any term of this Agreement is found to be illegal or unenforceable, the remaining portions of this Agreement shall remain in effect, provided that the parties agree to negotiate in good faith substitute enforceable terms.<br/><br/> Modifications; Special Agreements; Entire Agreement. Note that Tomedes reserves the right from time to time to amend, modify or change this agreement. Due to the majority of parties requesting not to be contacted via email about updates to the site, email notice will not always be given. Additionally, due to the financial costs associated with written notices...written notice will not always be given. If you are interested in keeping abreast of the latest changes to this agreement, then please bookmark this page and review it from time to time.<br/><br/> IF ANY MODIFICATION IS UNACCEPTABLE TO YOU, YOUR ONLY RECOURSE IS TO TERMINATE THIS AGREEMENT BY PROVIDING NOTICE TO US. YOUR CONTINUED PARTICIPATION IN THE PROGRAM FOLLOWING OUR POSTING OF A CHANGE NOTICE OR NEW AGREEMENT ON OUR SITE WILL CONSTITUTE BINDING ACCEPTANCE OF THE CHANGE.<br/><br/> Should Tomedes and the User come to a special understanding not outlined in this agreement it will be laid out in writing and signed by both parties.<br/><br/> This Agreement is the entire understanding between User and Tomedes with respect to the subject matter of this Agreement, and supersedes all (i) proposals, oral or written, (ii) negotiations, conversations or discussions between the parties and (iii) industry custom or past course of dealing, relating to the subject matter.",
        fr: "Assignment. User shall not assign or transfer this Agreement without Tomedes's prior written consent, which shall not be unreasonably withheld. Any attempted assignment shall be null and void. Relationship of the Parties. This Agreement does not create a franchise, joint venture or partnership between the parties. Neither party hereunder is the agent, broker, partner, employee, or legal representative of the other for any purpose. Excused Performance. Neither party shall be liable for failure to perform its obligations under this Agreement for causes beyond its reasonable control. No Waiver. The failure of either party to enforce any of the provisions hereof shall not be construed to be a waiver of the right of such party to thereafter enforce any such provision.<br/><br/> Unenforceable Provisions. If any term of this Agreement is found to be illegal or unenforceable, the remaining portions of this Agreement shall remain in effect, provided that the parties agree to negotiate in good faith substitute enforceable terms.<br/><br/> Modifications; Special Agreements; Entire Agreement. Note that Tomedes reserves the right from time to time to amend, modify or change this agreement. Due to the majority of parties requesting not to be contacted via email about updates to the site, email notice will not always be given. Additionally, due to the financial costs associated with written notices...written notice will not always be given. If you are interested in keeping abreast of the latest changes to this agreement, then please bookmark this page and review it from time to time.<br/><br/> IF ANY MODIFICATION IS UNACCEPTABLE TO YOU, YOUR ONLY RECOURSE IS TO TERMINATE THIS AGREEMENT BY PROVIDING NOTICE TO US. YOUR CONTINUED PARTICIPATION IN THE PROGRAM FOLLOWING OUR POSTING OF A CHANGE NOTICE OR NEW AGREEMENT ON OUR SITE WILL CONSTITUTE BINDING ACCEPTANCE OF THE CHANGE.<br/><br/> Should Tomedes and the User come to a special understanding not outlined in this agreement it will be laid out in writing and signed by both parties.<br/><br/> This Agreement is the entire understanding between User and Tomedes with respect to the subject matter of this Agreement, and supersedes all (i) proposals, oral or written, (ii) negotiations, conversations or discussions between the parties and (iii) industry custom or past course of dealing, relating to the subject matter.",
      },
    },
  ],
};
export const TermsctaWithFormData = {
  title: {
    default: "Ready to get started?",
    en: "Ready to get started?",
    fr: "Ready to get started?",
  },
  policyAgreement: {
    default: "*By submitting, you agree to LexTranscribe's Privacy Policy.",
    en: "*By submitting, you agree to LexTranscribe's Privacy Policy.",
    fr: "*By submitting, you agree to LexTranscribe's Privacy Policy.",
  },
  placeholder: {
    name: {
      default: "Name",
      en: "Name",
      fr: "Name",
    },
    email: {
      default: "Email Address",
      en: "Email Address",
      fr: "Email Address",
    },
  },
  btnText: {
    default: "SUBMIT",
    en: "SUBMIT",
    fr: "SUBMIT",
  },
};

export const privacyPolicyData = {
  title: {
    default: "Privacy Policy",
    en: "Privacy Policy",
    fr: "Privacy Policy",
  },
  subTitle: {
    default:
      "PLEASE READ THE FOLLOWING CAREFULLY. THE AFOREMENTIONED IS THE PRIVACY POLICY THAT GOVERNS YOUR USE OF ANY TOMEDES SERVIC",
    en: "PLEASE READ THE FOLLOWING CAREFULLY. THE AFOREMENTIONED IS THE PRIVACY POLICY THAT GOVERNS YOUR USE OF ANY TOMEDES SERVIC",
    fr: "PLEASE READ THE FOLLOWING CAREFULLY. THE AFOREMENTIONED IS THE PRIVACY POLICY THAT GOVERNS YOUR USE OF ANY TOMEDES SERVIC",
  },
  subTitlePara: {
    default:
      "This document is a legal agreement between you, the 'User' (as defined below) and Tomedes. These User's Terms and Conditions ('Agreement') sets forth the provisions under which the User may register and use the web-site for the purpose of responding to solicitations for the acquisition of solutions, services, and products ,providing these solutions, services, and products and taking care of requested revisions of the software solutions, services, and products.<br/><br/> DEFINITIONS Site (s): Tomedes Ltd: (if applicable) is the parent company and owner of the site hereinafter referred to as Tomedes. User: Individual (s) or a Company posting a project. Provider: Individual (s) or a Company providing a service.",
    en: "This document is a legal agreement between you, the 'User' (as defined below) and Tomedes. These User's Terms and Conditions ('Agreement') sets forth the provisions under which the User may register and use the web-site for the purpose of responding to solicitations for the acquisition of solutions, services, and products ,providing these solutions, services, and products and taking care of requested revisions of the software solutions, services, and products.<br/><br/> DEFINITIONS Site (s): Tomedes Ltd: (if applicable) is the parent company and owner of the site hereinafter referred to as Tomedes. User: Individual (s) or a Company posting a project. Provider: Individual (s) or a Company providing a service.",
    fr: "This document is a legal agreement between you, the 'User' (as defined below) and Tomedes. These User's Terms and Conditions ('Agreement') sets forth the provisions under which the User may register and use the web-site for the purpose of responding to solicitations for the acquisition of solutions, services, and products ,providing these solutions, services, and products and taking care of requested revisions of the software solutions, services, and products.<br/><br/> DEFINITIONS Site (s): Tomedes Ltd: (if applicable) is the parent company and owner of the site hereinafter referred to as Tomedes. User: Individual (s) or a Company posting a project. Provider: Individual (s) or a Company providing a service.",
  },
  listData: [
    {
      id: 1,
      heading: {
        default: "Collected Information",
        en: "Collected Information",
        fr: "Collected Information",
      },
      paraText: {
        default:
          "If you choose to use and or purchase a Tomedes product or place an order with us, we may ask you to provide us with certain personal information, such as your name, physical and electronic mail ('e-mail') addresses, phone number, domain name and other information that by itself, or in combination with other information, may be identifiable to you as a specific individual. We may also ask for financial information, such as account or credit card numbers, and demographic information, such as your zip code.<br/><br/> Please be aware that Tomedes advertisers, and web sites that have links on our sites, and provider/distributor partners may also collect personally identifiable information about you. The information practices of these Internet access partners, advertisers, and web sites linked to Tomedes and provider/distributor partners, are not governed by this Privacy Policy. What these other sites do with that information is governed by the privacy policy for that site and not this policy. You are encouraged to review the privacy policy on any site you visit.",
        en: "If you choose to use and or purchase a Tomedes product or place an order with us, we may ask you to provide us with certain personal information, such as your name, physical and electronic mail ('e-mail') addresses, phone number, domain name and other information that by itself, or in combination with other information, may be identifiable to you as a specific individual. We may also ask for financial information, such as account or credit card numbers, and demographic information, such as your zip code.<br/><br/> Please be aware that Tomedes advertisers, and web sites that have links on our sites, and provider/distributor partners may also collect personally identifiable information about you. The information practices of these Internet access partners, advertisers, and web sites linked to Tomedes and provider/distributor partners, are not governed by this Privacy Policy. What these other sites do with that information is governed by the privacy policy for that site and not this policy. You are encouraged to review the privacy policy on any site you visit.",
        fr: "If you choose to use and or purchase a Tomedes product or place an order with us, we may ask you to provide us with certain personal information, such as your name, physical and electronic mail ('e-mail') addresses, phone number, domain name and other information that by itself, or in combination with other information, may be identifiable to you as a specific individual. We may also ask for financial information, such as account or credit card numbers, and demographic information, such as your zip code.<br/><br/> Please be aware that Tomedes advertisers, and web sites that have links on our sites, and provider/distributor partners may also collect personally identifiable information about you. The information practices of these Internet access partners, advertisers, and web sites linked to Tomedes and provider/distributor partners, are not governed by this Privacy Policy. What these other sites do with that information is governed by the privacy policy for that site and not this policy. You are encouraged to review the privacy policy on any site you visit.",
      },
    },
    {
      id: 2,
      heading: {
        default: "Information Requests",
        en: "Information Requests",
        fr: "Information Requests",
      },
      paraText: {
        default:
          "You may be able to request information on our sites regarding products and Services, including technical support and customer Service, by using online forms. We may ask that you provide certain contact information to allow us to fulfill your request and to send you information about Tomedes products and Services.",
        en: "You may be able to request information on our sites regarding products and Services, including technical support and customer Service, by using online forms. We may ask that you provide certain contact information to allow us to fulfill your request and to send you information about Tomedes products and Services.",
        fr: "You may be able to request information on our sites regarding products and Services, including technical support and customer Service, by using online forms. We may ask that you provide certain contact information to allow us to fulfill your request and to send you information about Tomedes products and Services.",
      },
    },
    {
      id: 3,
      heading: {
        default: "Security",
        en: "Security",
        fr: "Security",
      },
      paraText: {
        default:
          "Ordering online for a Tomedes product or service is secure and convenient. Our ordering process is protected by the Secure Sockets Layer (SSL') protocol, which encrypts your information and confirms the identity of the Tomedes server before completing your transaction. Netscape Navigator 2.0 + (or better) and Internet Explorer 3.0+ (or better) support the SSL protocol. We recommend you use the latest browsers to ensure that you are protected by advances in security technology.",
        en: "Ordering online for a Tomedes product or service is secure and convenient. Our ordering process is protected by the Secure Sockets Layer (SSL') protocol, which encrypts your information and confirms the identity of the Tomedes server before completing your transaction. Netscape Navigator 2.0 + (or better) and Internet Explorer 3.0+ (or better) support the SSL protocol. We recommend you use the latest browsers to ensure that you are protected by advances in security technology.",
        fr: "Ordering online for a Tomedes product or service is secure and convenient. Our ordering process is protected by the Secure Sockets Layer (SSL') protocol, which encrypts your information and confirms the identity of the Tomedes server before completing your transaction. Netscape Navigator 2.0 + (or better) and Internet Explorer 3.0+ (or better) support the SSL protocol. We recommend you use the latest browsers to ensure that you are protected by advances in security technology.",
      },
    },
    {
      id: 4,
      heading: {
        default: "Children's Guidelines",
        en: "Children's Guidelines",
        fr: "Children's Guidelines",
      },
      paraText: {
        default:
          "Ordering online for a Tomedes product or service is secure and convenient. Our ordering process is protected by the Secure Sockets Layer ('SSL') protocol, which encrypts your information and confirms the identity of the Tomedes server before completing your transaction. Netscape Navigator 2.0 + (or better) and Internet Explorer 3.0+ (or better) support the SSL protocol. We recommend you use the latest browsers to ensure that you are protected by advances in security technology.",
        en: "Ordering online for a Tomedes product or service is secure and convenient. Our ordering process is protected by the Secure Sockets Layer ('SSL') protocol, which encrypts your information and confirms the identity of the Tomedes server before completing your transaction. Netscape Navigator 2.0 + (or better) and Internet Explorer 3.0+ (or better) support the SSL protocol. We recommend you use the latest browsers to ensure that you are protected by advances in security technology.",
        fr: "Ordering online for a Tomedes product or service is secure and convenient. Our ordering process is protected by the Secure Sockets Layer ('SSL') protocol, which encrypts your information and confirms the identity of the Tomedes server before completing your transaction. Netscape Navigator 2.0 + (or better) and Internet Explorer 3.0+ (or better) support the SSL protocol. We recommend you use the latest browsers to ensure that you are protected by advances in security technology.",
      },
    },
    {
      id: 5,
      heading: {
        default: "Children's Guidelines",
        en: "Children's Guidelines",
        fr: "Children's Guidelines",
      },
      paraText: {
        default:
          "Although some of Tomedes sites are not geared towards children, Tomedes nonetheless attempts to protect children. Tomedes must, however, rely on the information provided to us by visitors to our sites. As a result, it is impossible for us to guarantee with absolute certainty that the information collected and utilized by Tomedes is not derived from a child.",
        en: "Although some of Tomedes sites are not geared towards children, Tomedes nonetheless attempts to protect children. Tomedes must, however, rely on the information provided to us by visitors to our sites. As a result, it is impossible for us to guarantee with absolute certainty that the information collected and utilized by Tomedes is not derived from a child.",
        fr: "Although some of Tomedes sites are not geared towards children, Tomedes nonetheless attempts to protect children. Tomedes must, however, rely on the information provided to us by visitors to our sites. As a result, it is impossible for us to guarantee with absolute certainty that the information collected and utilized by Tomedes is not derived from a child.",
      },
    },
    {
      id: 6,
      heading: {
        default: "Disclosure",
        en: "Disclosure",
        fr: "Disclosure",
      },
      paraText: {
        default:
          "Tomedes will not sell, rent, trade, or disclose individual Customer information to any third parties or outside companies who will use the information to contact you or who will share the information with others without your permission. It may be necessary to disclose information in special cases when we have reason to believe that disclosing the information is necessary to identify, contact or bring legal action against someone who may be violating Tomedes policies or may be causing injury to or interference with (either intentionally or unintentionally) the rights or property of Tomedes, other Tomedes users, or anyone else that could be harmed by such activities. Tomedes may disclose or access account information when we believe in good faith that the law requires it or for administrative and other purposes that we deem necessary to maintain, service, and improve our products and Services.",
        en: "Tomedes will not sell, rent, trade, or disclose individual Customer information to any third parties or outside companies who will use the information to contact you or who will share the information with others without your permission. It may be necessary to disclose information in special cases when we have reason to believe that disclosing the information is necessary to identify, contact or bring legal action against someone who may be violating Tomedes policies or may be causing injury to or interference with (either intentionally or unintentionally) the rights or property of Tomedes, other Tomedes users, or anyone else that could be harmed by such activities. Tomedes may disclose or access account information when we believe in good faith that the law requires it or for administrative and other purposes that we deem necessary to maintain, service, and improve our products and Services.",
        fr: "Tomedes will not sell, rent, trade, or disclose individual Customer information to any third parties or outside companies who will use the information to contact you or who will share the information with others without your permission. It may be necessary to disclose information in special cases when we have reason to believe that disclosing the information is necessary to identify, contact or bring legal action against someone who may be violating Tomedes policies or may be causing injury to or interference with (either intentionally or unintentionally) the rights or property of Tomedes, other Tomedes users, or anyone else that could be harmed by such activities. Tomedes may disclose or access account information when we believe in good faith that the law requires it or for administrative and other purposes that we deem necessary to maintain, service, and improve our products and Services.",
      },
    },
    {
      id: 7,
      heading: {
        default: "Use of Information",
        en: "Use of Information",
        fr: "Use of Information",
      },
      paraText: {
        default:
          "The use of an individual's e-mail address is necessary to keep our Customers well informed of maintenance issues, escalated critical issues and problem resolutions that may arise with your Tomedes Service. We may also use email addresses to provide our customers with informative newsletters, marketing messages, promotional materials, and other information that may be of interest to you. If you do not want us to use your data in this way, simply do not opt-in when we ask for your consent on the relevant forms where we collect your data. Or you can unsubscribe by sending your request to support@tomedes.com.<br/><br/> We like to keep our Customers informed via e-mail and other means. Sometimes Tomedes uses personal and demographic information to help us determine which Tomedes products and Services are most likely to be of interest to you or help diagnose problems with our servers or administration of our sites. We also use demographic information to gather general interest in our products, to help in the analysis of product usage, purchasing, and target markets.<br/><br/> Please note that Tomedes does provide information to outside companies (such as a credit card processing company) who perform certain functions on our behalf for billing purposes. We will not permit those companies to use the gathered information for other than the stated purpose.",
        en: "The use of an individual's e-mail address is necessary to keep our Customers well informed of maintenance issues, escalated critical issues and problem resolutions that may arise with your Tomedes Service. We may also use email addresses to provide our customers with informative newsletters, marketing messages, promotional materials, and other information that may be of interest to you. If you do not want us to use your data in this way, simply do not opt-in when we ask for your consent on the relevant forms where we collect your data. Or you can unsubscribe by sending your request to support@tomedes.com.<br/><br/> We like to keep our Customers informed via e-mail and other means. Sometimes Tomedes uses personal and demographic information to help us determine which Tomedes products and Services are most likely to be of interest to you or help diagnose problems with our servers or administration of our sites. We also use demographic information to gather general interest in our products, to help in the analysis of product usage, purchasing, and target markets.<br/><br/> Please note that Tomedes does provide information to outside companies (such as a credit card processing company) who perform certain functions on our behalf for billing purposes. We will not permit those companies to use the gathered information for other than the stated purpose.",
        fr: "The use of an individual's e-mail address is necessary to keep our Customers well informed of maintenance issues, escalated critical issues and problem resolutions that may arise with your Tomedes Service. We may also use email addresses to provide our customers with informative newsletters, marketing messages, promotional materials, and other information that may be of interest to you. If you do not want us to use your data in this way, simply do not opt-in when we ask for your consent on the relevant forms where we collect your data. Or you can unsubscribe by sending your request to support@tomedes.com.<br/><br/> We like to keep our Customers informed via e-mail and other means. Sometimes Tomedes uses personal and demographic information to help us determine which Tomedes products and Services are most likely to be of interest to you or help diagnose problems with our servers or administration of our sites. We also use demographic information to gather general interest in our products, to help in the analysis of product usage, purchasing, and target markets.<br/><br/> Please note that Tomedes does provide information to outside companies (such as a credit card processing company) who perform certain functions on our behalf for billing purposes. We will not permit those companies to use the gathered information for other than the stated purpose.",
      },
    },
    {
      id: 8,
      heading: {
        default: "Correct/Update",
        en: "Correct/Update",
        fr: "Correct/Update",
      },
      paraText: {
        default:
          "If you would like to change or modify information you have previously provided to us, please contact us here.",
        en: "If you would like to change or modify information you have previously provided to us, please contact us here.",
        fr: "If you would like to change or modify information you have previously provided to us, please contact us here.",
      },
    },
    {
      id: 9,
      heading: {
        default: "Cookies",
        en: "Cookies",
        fr: "Cookies",
      },
      paraText: {
        default:
          "Some of the websites we host place small bits of text or 'cookies' onto your computer's hard drive. Cookies enable us to deliver content specific to your interests and keep track of your password so you do not have to re-enter it each time you visit our web sites. After you accept a cookie, it is passed from your browser to our servers each time you request a page. This cookie consists of a unique token that anonymously identifies to the server so that you can more easily access the features of the Tomedes Service. Please note that you may configure your web browser to warn you before you accept a cookie.",
        en: "Some of the websites we host place small bits of text or 'cookies' onto your computer's hard drive. Cookies enable us to deliver content specific to your interests and keep track of your password so you do not have to re-enter it each time you visit our web sites. After you accept a cookie, it is passed from your browser to our servers each time you request a page. This cookie consists of a unique token that anonymously identifies to the server so that you can more easily access the features of the Tomedes Service. Please note that you may configure your web browser to warn you before you accept a cookie.",
        fr: "Some of the websites we host place small bits of text or 'cookies' onto your computer's hard drive. Cookies enable us to deliver content specific to your interests and keep track of your password so you do not have to re-enter it each time you visit our web sites. After you accept a cookie, it is passed from your browser to our servers each time you request a page. This cookie consists of a unique token that anonymously identifies to the server so that you can more easily access the features of the Tomedes Service. Please note that you may configure your web browser to warn you before you accept a cookie.",
      },
    },
    {
      id: 10,
      heading: {
        default: "Customer E-mails",
        en: "Customer E-mails",
        fr: "Customer E-mails",
      },
      paraText: {
        default:
          "Tomedes will not read or disclose e-mail content to others unless required by law or deemed necessary to operate our services.",
        en: "Tomedes will not read or disclose e-mail content to others unless required by law or deemed necessary to operate our services.",
        fr: "Tomedes will not read or disclose e-mail content to others unless required by law or deemed necessary to operate our services.",
      },
    },
    {
      id: 11,
      heading: {
        default: "Contacting the Web Site",
        en: "Contacting the Web Site",
        fr: "Contacting the Web Site",
      },
      paraText: {
        default:
          "If you have any questions about Tomedes privacy policy or the privacy practices of our web sites, please contact us",
        en: "If you have any questions about Tomedes privacy policy or the privacy practices of our web sites, please contact us",
        fr: "If you have any questions about Tomedes privacy policy or the privacy practices of our web sites, please contact us",
      },
    },
    {
      id: 12,
      heading: {
        default: "Changes to the Privacy Policy",
        en: "Changes to the Privacy Policy",
        fr: "Changes to the Privacy Policy",
      },
      paraText: {
        default:
          "In the event our Privacy Policy needs to be modified, those changes will be reflected in the next revision of this Privacy Policy which will be posted on the Tomedes web site. Please check back often to review any revisions.",
        en: "In the event our Privacy Policy needs to be modified, those changes will be reflected in the next revision of this Privacy Policy which will be posted on the Tomedes web site. Please check back often to review any revisions.",
        fr: "In the event our Privacy Policy needs to be modified, those changes will be reflected in the next revision of this Privacy Policy which will be posted on the Tomedes web site. Please check back often to review any revisions.",
      },
    },
  ],
};

// Pillar page Data
export const pillarPageBannerData = {
  title: {
    default: "Deposition Transcription Services Empower Your Legal Team",
    en: "Deposition Transcription Services Empower Your Legal Team",
    fr: "Deposition Transcription Services Empower Your Legal Team",
  },
  description: {
    default:
      "Are you running out of time to prepare for a deposition or trial? LexTranscribe offers precise deposition transcription services. A word-for-word account of witness testimony gives you the evidence required to construct a compelling trial strategy. Maximize your legal skills with world-class deposition transcription services.",
    en: "Are you running out of time to prepare for a deposition or trial? LexTranscribe offers precise deposition transcription services. A word-for-word account of witness testimony gives you the evidence required to construct a compelling trial strategy. Maximize your legal skills with world-class deposition transcription services.",
    fr: "Are you running out of time to prepare for a deposition or trial? LexTranscribe offers precise deposition transcription services. A word-for-word account of witness testimony gives you the evidence required to construct a compelling trial strategy. Maximize your legal skills with world-class deposition transcription services.",
  },
  btnText: {
    default: "GET STARTED",
    en: "GET STARTED",
    fr: "GET STARTED",
  },
  imgurl: {
    default: pillarBanner,
    en: pillarBanner,
    fr: pillarBanner,
  },
  sealDesktop: [
    {
      icon: "quality-guaranteed",
      text: "Guaranteed</br>Quality & Accuracy",
    },
    {
      icon: "expert-human",
      text: "Expert Human</br>Transcriptionists",
    },
    {
      icon: "fast-delivery-two",
      text: "Fast Delivery",
    },
    {
      icon: "secure",
      text: "Secure &</br>Confidential",
    },
  ],
  sealMobile: [
    {
      icon: "expert-human",
      text: "Expert Human</br>Transcriptionists",
    },
    {
      icon: "rating",
      text: "4.8 out of 5</br>Aggregate Rating",
    },
  ],
};

export const pillarPageTextRowData = {
  title: {
    default: "Deposition Transcription<br>Prepares You For Trial",
    en: "Deposition Transcription<br>Prepares You For Trial",
    fr: "Deposition Transcription<br>Prepares You For Trial",
  },
  highlightWords: {
    default: ["Deposition"],
    en: ["Deposition"],
    fr: ["Deposition"],
  },
  highlightedColor: "yellow",
  subtitle: {
    default:
      "You can’t afford to lose any time preparing for a trial. Whether you’re a prosecutor, law firm, or corporate legal department, our team delivers fast, accurate deposition transcription. We can help you streamline legal research, prepare witnesses, and develop winning strategies for trial.",
    en: "You can’t afford to lose any time preparing for a trial. Whether you’re a prosecutor, law firm, or corporate legal department, our team delivers fast, accurate deposition transcription. We can help you streamline legal research, prepare witnesses, and develop winning strategies for trial.",
    fr: "You can’t afford to lose any time preparing for a trial. Whether you’re a prosecutor, law firm, or corporate legal department, our team delivers fast, accurate deposition transcription. We can help you streamline legal research, prepare witnesses, and develop winning strategies for trial.",
  },
};

export const pillarPageUspdata = {
  imgurl: {
    default: transcribeImg,
    en: transcribeImg,
    fr: transcribeImg,
  },
  title: {
    default: "Transcribe<br> Your Legal Files In Three Simple Steps",
    en: "Transcribe<br> Your Legal Files In Three Simple Steps",
    fr: "Transcribe<br> Your Legal Files In Three Simple Steps",
  },
  description: {
    default:
      "1. Send your files over our secure network.<br>2. Pay online.<br>3. Receive your transcripts.",
    en: "1. Send your files over our secure network.<br>2. Pay online.<br>3. Receive your transcripts.",
    fr: "1. Send your files over our secure network.",
  },
  icon: "lock-white",
  securityText: {
    default: "Security, Privacy and Confidentiality Guarantee",
    en: "Security, Privacy and Confidentiality Guarantee",
    fr: "Security, Privacy and Confidentiality Guarantee",
  },
  securityText2: {
    default: "Your information is protected by 256-bit SSL encryption.",
    en: "Your information is protected by 256-bit SSL encryption.",
    fr: "Your information is protected by 256-bit SSL encryption.",
  },
  cta: {
    text: {
      default: "GET STARTED TODAY",
      en: "GET STARTED TODAY",
      fr: "GET STARTED TODAY",
    },
    href: "/contactus",
  },
};

export const pillarPageTwoColGridWithOrderData = {
  title: {
    default: "Why Choose Our<br> Deposition Transcription Agency?",
    en: "Why Choose Our<br> Deposition Transcription Agency?",
    fr: "Why Choose Our<br> Deposition Transcription Agency?",
  },
  highlightWords: {
    default: [" "],
    en: [" "],
    fr: [" "],
  },
  highlightedColor: "yellow",
  subTitle: {
    default:
      "The outcome of your case depends on which deposition transcription agency you choose. LexTranscribe understands how critical the accuracy of this transcript is to your success. We’re committed to providing the high-quality legal transcript you need.",
    en: "The outcome of your case depends on which deposition transcription agency you choose. LexTranscribe understands how critical the accuracy of this transcript is to your success. We’re committed to providing the high-quality legal transcript you need.",
    fr: "The outcome of your case depends on which deposition transcription agency you choose. LexTranscribe understands how critical the accuracy of this transcript is to your success. We’re committed to providing the high-quality legal transcript you need.",
  },
  items: [
    {
      image: {
        default: whyImg1,
        en: whyImg1,
        fr: whyImg1,
      },
      mainData: [
        {
          title: {
            default: "You Deserve A Certified Deposition Transcriptionist",
            en: "You Deserve A Certified Deposition Transcriptionist",
            fr: "You Deserve A Certified Deposition Transcriptionist",
          },
          highlightWords: {
            default: ["Certified"],
            en: ["Certified"],
            fr: ["Certified"],
          },
          highlightedColor: "yellow",
          description: {
            default:
              "Don’t settle for mediocre deposition transcription services. They’ll only let you down at the last minute. Our certified deposition transcriptionists have years of experience & specialized legal knowledge. Get accurate transcriptions of your deposition video now.",
            en: "Don’t settle for mediocre deposition transcription services. They’ll only let you down at the last minute. Our certified deposition transcriptionists have years of experience & specialized legal knowledge. Get accurate transcriptions of your deposition video now.",
            fr: "Don’t settle for mediocre deposition transcription services. They’ll only let you down at the last minute. Our certified deposition transcriptionists have years of experience & specialized legal knowledge. Get accurate transcriptions of your deposition video now.",
          },
        },
        {
          title: {
            default: "We Transcribe Depositions In Many<br>File Formats",
            en: "We Transcribe Depositions In Many<br>File Formats",
            fr: "We Transcribe Depositions In Many<br>File Formats",
          },
          highlightWords: {
            default: ["File Formats"],
            en: ["File Formats"],
            fr: ["File Formats"],
          },
          highlightedColor: "yellow",
          description: {
            default:
              "We’ll deliver your deposition transcripts in standard or custom format according to your requirements. For your convenience, we transcribe traditional or remote depositions in 50+ audio and video file types including but not limited to:",
            en: "We’ll deliver your deposition transcripts in standard or custom format according to your requirements. For your convenience, we transcribe traditional or remote depositions in 50+ audio and video file types including but not limited to:",
            fr: "We’ll deliver your deposition transcripts in standard or custom format according to your requirements. For your convenience, we transcribe traditional or remote depositions in 50+ audio and video file types including but not limited to:",
          },
          list: [
            {
              text: {
                default: "MP3 & MP4",
                en: "MP3 & MP4",
                fr: "MP3 & MP4",
              },
            },
            {
              text: {
                default: "Windows Media Audio - WMA",
                en: "Windows Media Audio - WMA",
                fr: "Windows Media Audio - WMA",
              },
            },
            {
              text: {
                default: "Waveform Audio - WAV",
                en: "Waveform Audio - WAV",
                fr: "Waveform Audio - WAV",
              },
            },
            {
              text: {
                default: "Audio Interchange File - AIFF",
                en: "Audio Interchange File - AIFF",
                fr: "Audio Interchange File - AIFF",
              },
            },
            {
              text: {
                default: "Digital Speech<br>Standard - DSS",
                en: "Digital Speech<br>Standard - DSS",
                fr: "Digital Speech<br>Standard - DSS",
              },
            },
            {
              text: {
                default: "Quick Time Movie - MOV",
                en: "Quick Time Movie - MOV",
                fr: "Quick Time Movie - MOV",
              },
            },
          ],
        },
      ],
    },
    {
      image: {
        default: whyImg2,
        en: whyImg2,
        fr: whyImg2,
      },

      mainData: [
        {
          title: {
            default: "We Support Your Success With Postproduction Services",
            en: "We Support Your Success With Postproduction Services",
            fr: "We Support Your Success With Postproduction Services",
          },
          highlightWords: {
            default: ["Support"],
            en: ["Support"],
            fr: ["Support"],
          },
          highlightedColor: "yellow",
          description: {
            default:
              "Far too often, companies leave clients to fend for themselves. However, we provide postproduction services one year after your transcription, such as subtitles & captions for the deposition video. We are dedicated to helping you succeed.",
            en: "Far too often, companies leave clients to fend for themselves. However, we provide postproduction services one year after your transcription, such as subtitles & captions for the deposition video. We are dedicated to helping you succeed.",
            fr: "Far too often, companies leave clients to fend for themselves. However, we provide postproduction services one year after your transcription, such as subtitles & captions for the deposition video. We are dedicated to helping you succeed.",
          },
        },
        {
          title: {
            default: "We Safeguard Your Data Security & Confidentiality",
            en: "We Safeguard Your Data Security & Confidentiality",
            fr: "We Safeguard Your Data Security & Confidentiality",
          },
          highlightWords: {
            default: ["Data Security"],
            en: ["Data Security"],
            fr: ["Data Security"],
          },
          highlightedColor: "yellow",
          description: {
            default:
              "Viruses, malware, and hackers put your data and confidentiality at risk. We understand security and confidentiality are crucial in the legal sector. LexTranscibe features SSL encryption and strict security protocols to transmit, process, and store your sensitive files.",
            en: "Viruses, malware, and hackers put your data and confidentiality at risk. We understand security and confidentiality are crucial in the legal sector. LexTranscibe features SSL encryption and strict security protocols to transmit, process, and store your sensitive files.",
            fr: "Viruses, malware, and hackers put your data and confidentiality at risk. We understand security and confidentiality are crucial in the legal sector. LexTranscibe features SSL encryption and strict security protocols to transmit, process, and store your sensitive files.",
          },
        },
      ],
    },
    {
      image: {
        default: whyImg3,
        en: whyImg3,
        fr: whyImg3,
      },

      mainData: [
        {
          title: {
            default:
              "Our Fast Transcript Delivery Helps You Meet Urgent Deadlines",
            en: "Our Fast Transcript Delivery Helps You Meet Urgent Deadlines",
            fr: "Our Fast Transcript Delivery Helps You Meet Urgent Deadlines",
          },
          highlightWords: {
            default: ["Fast"],
            en: ["Fast"],
            fr: ["Fast"],
          },
          highlightedColor: "yellow",
          description: {
            default:
              "When the clock is ticking, you don’t have time to wait. We deliver deposition transcripts when and how you need them, even for the most stringent deadlines. Receive fast, accurate transcripts & strengthen your case before trial.",
            en: "When the clock is ticking, you don’t have time to wait. We deliver deposition transcripts when and how you need them, even for the most stringent deadlines. Receive fast, accurate transcripts & strengthen your case before trial.",
            fr: "When the clock is ticking, you don’t have time to wait. We deliver deposition transcripts when and how you need them, even for the most stringent deadlines. Receive fast, accurate transcripts & strengthen your case before trial.",
          },
        },
        {
          title: {
            default:
              "We Provide Scalable, Cost-Effective Solutions For Your Workflow Problems",
            en: "We Provide Scalable, Cost-Effective Solutions For Your Workflow Problems",
            fr: "We Provide Scalable, Cost-Effective Solutions For Your Workflow Problems",
          },
          highlightWords: {
            default: ["Cost-Effective"],
            en: ["Cost-Effective"],
            fr: ["Cost-Effective"],
          },
          highlightedColor: "yellow",
          description: {
            default:
              "Are backlogs and disorganized files bringing your law firm’s productivity to a halt? If so, we can transcribe large volumes of legal files into searchable digital transcripts. Let us help increase your productivity.",
            en: "Are backlogs and disorganized files bringing your law firm’s productivity to a halt? If so, we can transcribe large volumes of legal files into searchable digital transcripts. Let us help increase your productivity.",
            fr: "Are backlogs and disorganized files bringing your law firm’s productivity to a halt? If so, we can transcribe large volumes of legal files into searchable digital transcripts. Let us help increase your productivity.",
          },
        },
      ],
    },
  ],
};

export const pillarPageCtaData = {
  heading: {
    default: "Ready to reap the benefits of accurate deposition transcripts?",
    en: "Ready to reap the benefits of accurate deposition transcripts?",
    fr: "Ready to reap the benefits of accurate deposition transcripts?",
  },
  text: {
    default: "CONTACT US",
    en: "CONTACT US",
    fr: "CONTACT US",
  },
  href: {
    default: "/contactus",
    en: "/contactus",
    fr: "/contactus",
  },
};
export const securityPageCtaData = {
  heading: {
    default:
      "Contact us to learn more about our commitment to your confidentiality.",
    en: "Contact us to learn more about our commitment to your confidentiality.",
    fr: "Contact us to learn more about our commitment to your confidentiality.",
  },
  text: {
    default: "CONTACT US",
    en: "CONTACT US",
    fr: "CONTACT US",
  },
  href: {
    default: "/contactus",
    en: "/contactus",
    fr: "/contactus",
  },
};

export const pillarPageOnSideData = {
  title: {
    default:
      "Deposition Transcriptionists Available In Major Cities Throughout The United States",
    en: "Deposition Transcriptionists Available In Major Cities Throughout The United States",
    fr: "Deposition Transcriptionists Available In Major Cities Throughout The United States",
  },
  highlightWords: {
    default: ["Deposition Transcriptionists"],
    en: ["Deposition Transcriptionists"],
    fr: ["Deposition Transcriptionists"],
  },
  highlightedColor: "yellow",
  description: {
    default:
      "Say goodbye to long delays. Get fast, accurate deposition transcripts near you when you need them. Our deposition transcriptionists have extensive experience in US laws and regulations. Get certified deposition transcripts in major US cities from Beverly Hills to New York.",
    en: "Say goodbye to long delays. Get fast, accurate deposition transcripts near you when you need them. Our deposition transcriptionists have extensive experience in US laws and regulations. Get certified deposition transcripts in major US cities from Beverly Hills to New York.",
    fr: "Say goodbye to long delays. Get fast, accurate deposition transcripts near you when you need them. Our deposition transcriptionists have extensive experience in US laws and regulations. Get certified deposition transcripts in major US cities from Beverly Hills to New York.",
  },
};
export const pillarPageSupportedLanguagesData = {
  title: {
    default: "Insert Optional Section for Clusters",
    en: "Insert Optional Section for Clusters",
    fr: "Insert Optional Section for Clusters",
  },
  highlightWords: {
    default: ["Clusters"],
    en: ["Clusters"],
    fr: [],
  },
  highlightedColor: "yellow",
  page_content: {
    default:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation. </br>Ut enim ad minim veniam, quis nostrud exercitation.",
    en: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation. </br>Ut enim ad minim veniam, quis nostrud exercitation.",
    fr: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation. </br>Ut enim ad minim veniam, quis nostrud exercitation.",
  },
  languages: [
    {
      id: 0,
      text: {
        default: "Cluster",
        en: "Cluster",
        fr: "Cluster",
      },
      link: "",
    },
    {
      id: 1,
      text: {
        default: "Cluster",
        en: "Cluster",
        fr: "Cluster",
      },
      link: "",
    },
    {
      id: 2,
      text: {
        default: "Cluster",
        en: "Cluster",
        fr: "Cluster",
      },
      link: "",
    },
    {
      id: 3,
      text: {
        default: "Cluster",
        en: "Cluster",
        fr: "Cluster",
      },
      link: "",
    },
    {
      id: 4,
      text: {
        default: "Cluster",
        en: "Cluster",
        fr: "Cluster",
      },
      link: "",
    },
    {
      id: 5,
      text: {
        default: "Cluster",
        en: "Cluster",
        fr: "Cluster",
      },
      link: "",
    },
    {
      id: 6,
      text: {
        default: "Cluster",
        en: "Cluster",
        fr: "Cluster",
      },
      link: "",
    },
    {
      id: 7,
      text: {
        default: "Cluster",
        en: "Cluster",
        fr: "Cluster",
      },
      link: "",
    },
    {
      id: 8,
      text: {
        default: "Cluster",
        en: "Cluster",
        fr: "Cluster",
      },
      link: "",
    },
    {
      id: 9,
      text: {
        default: "Cluster",
        en: "Cluster",
        fr: "Cluster",
      },
      link: "",
    },
  ],
};

export const ratingData = {
  achievedstars: {
    default: "4.9 out of 5",
    en: "4.9 out of 5",
    fr: "Add french translation",
  },
  totalstars: {
    default: "out of 5",
    en: "out of 5",
    fr: "Add french translation",
  },
  Ratinghead: {
    default: "Aggregate Rating",
    en: "Aggregate Rating",
    fr: "Nos clients en parlent le mieux",
  },
  ratingsummary: {
    default: " (Out of 1798 Verified Reviews Online)",
    en: " (Out of 1798 Verified Reviews Online)",
    fr: " (add french translation)",
  },
  achievedstarsfigure: "5",
  ratingcontent: {
    description: {
      default:
        "Tomedes takes pride in 95,000+ satisfied customers, around the globe, a number that includes several Fortune 500 companies. We have a 4.9 out of 5 aggregate star rating from 1,798 online reviews.",
      en: "Tomedes takes pride in 95,000+ satisfied customers, around the globe, a number that includes several Fortune 500 companies. We have a 4.9 out of 5 aggregate star rating from 1,798 online reviews.",
      fr: "Tomedes takes pride in 95,000+ satisfied customers, around the globe, a number that includes several Fortune 500 companies. We have a 4.9 out of 5 aggregate star rating from 1,798 online reviews.",
    },
    highlightWords: {
      default: ["1,798 online reviews."],
      en: ["1,798 online reviews."],
      fr: ["french"],
    },
    highlightedColor: "blue font-bold",
  },
  cta: {
    text: {
      default: "SEE ALL REVIEWS",
      en: "SEE ALL REVIEWS",
      fr: "Add french translation",
    },
    href: "/reviews.php",
  },
  testimonialhead: {
    default: "See what our clients have to say about us:",
    en: "See what our clients have to say about us:",
    fr: "Add french translation",
  },
  testimonialdata: [
    {
      content: {
        default: "Speedy return & reasonably priced",
        en: "Speedy return & reasonably priced",
        fr: "Add french translation",
      },
      name: {
        default: "Katherine Lindsay",
        en: "Katherine Lindsay",
        fr: "Add french translation",
      },
      id: 1,
      title: {
        default: "BBC",
        en: "BBC",
        fr: "Add french translation",
      },
      icon: "bbc",
      className: "w-16 h-5",
      href: "https://www.trustpilot.com/users/60db02325f811c001128d575",
    },
    {
      content: {
        default:
          "Tomedes has been nothing but kind, knowledgeable and efficient!",
        en: "Tomedes has been nothing but kind, knowledgeable and efficient!",
        fr: "Add french translation",
      },
      name: {
        default: "Ashrena Ali",
        en: "Ashrena Ali",
        fr: "Add french translation",
      },
      id: 2,
      title: {
        default: "Ashrena Ali",
        en: "Ashrena Ali",
        fr: "Add french translation",
      },
      icon: "ashrena",
      className: "w-9 h-9",
      href: "https://www.trustpilot.com/users/60945782a8fc63001b6f847b",
    },
    {
      content: {
        default: "Tomedes is a high quality translation provider",
        en: "Tomedes is a high quality translation provider",
        fr: "Add french translation",
      },
      name: {
        default: "Jorge Castro",
        en: "Jorge Castro",
        fr: "Add french translation",
      },
      id: 3,
      title: {
        default: "CODE",
        en: "CODE",
        fr: "Add french translation",
      },
      icon: "code",
      className: "w-9 h-9",
      href: "https://www.trustpilot.com/reviews/61b11ffd2b49257fe29a48fa",
    },
  ],
};

export const pillarPageAccordionData = {
  title: {
    default: "Frequently Asked Questions",
    en: "Frequently Asked Questions",
    fr: "Frequently Asked Questions",
  },
  accordionItems: [
    {
      heading: {
        default: "What is a certified deposition transcript?",
        en: "What is a certified deposition transcript?",
        fr: "What is a certified deposition transcript?",
      },
      description: {
        default:
          "A certified deposition transcript is a legal transcript certified by the transcriptionist who prepared it and willing to stand by the accuracy of their work. Law firms & businesses prefer certified deposition transcripts because these documents are admissible in US courts.",
        en: "A certified deposition transcript is a legal transcript certified by the transcriptionist who prepared it and willing to stand by the accuracy of their work. Law firms & businesses prefer certified deposition transcripts because these documents are admissible in US courts.",
        fr: "A certified deposition transcript is a legal transcript certified by the transcriptionist who prepared it and willing to stand by the accuracy of their work. Law firms & businesses prefer certified deposition transcripts because these documents are admissible in US courts.",
      },
    },
    {
      heading: {
        default: "How long does it take to transcribe a deposition?",
        en: "How long does it take to transcribe a deposition?",
        fr: "How long does it take to transcribe a deposition?",
      },
      description: {
        default:
          "Don’t wait a week to 10 days for a court reporter to transcribe your deposition. LexTranscribe delivers fast, accurate transcription for your urgent requests.<br><br>Choose from our convenient options: best price deposition transcription, fast delivery deposition transcription, or <a href='contactus' class='font-medium underline hover:text-yellow'>custom transcription tailored to your deadline.</a>",
        en: "Don’t wait a week to 10 days for a court reporter to transcribe your deposition. LexTranscribe delivers fast, accurate transcription for your urgent requests.<br><br>Choose from our convenient options: best price deposition transcription, fast delivery deposition transcription, or <a href='contactus' class='font-medium underline hover:text-yellow'>custom transcription tailored to your deadline.</a>",
        fr: "Don’t wait a week to 10 days for a court reporter to transcribe your deposition. LexTranscribe delivers fast, accurate transcription for your urgent requests.<br><br>Choose from our convenient options: best price deposition transcription, fast delivery deposition transcription, or custom transcription tailored[ Link to contact us] to your deadline.",
      },
    },
  ],
};

// About us page data
export const aboutUsBannerData = {
  title: {
    default: "About Us",
    en: "About Us",
    fr: "About Us",
  },
  description: {
    default:
      "LexTranscribe is the premier legal transcription agency trusted by top legal institutions in the US and worldwide. Our transcriptionists deliver certified legal transcriptions, specializing in a variety of areas, including litigation, arbitration, depositions, law enforcement, medico-legal, and much more.",
    en: "LexTranscribe is the premier legal transcription agency trusted by top legal institutions in the US and worldwide. Our transcriptionists deliver certified legal transcriptions, specializing in a variety of areas, including litigation, arbitration, depositions, law enforcement, medico-legal, and much more.",
    fr: "LexTranscribe is the premier legal transcription agency trusted by top legal institutions in the US and worldwide. Our transcriptionists deliver certified legal transcriptions, specializing in a variety of areas, including litigation, arbitration, depositions, law enforcement, medico-legal, and much more.",
  },

  imgurl: {
    default: aboutusBanner,
    en: aboutusBanner,
    fr: aboutusBanner,
  },
  sealDesktop: [
    {
      icon: "quality-guaranteed",
      text: "Guaranteed</br>Quality Accuracy",
    },
    {
      icon: "expert-human",
      text: "Expert Human</br>Transcriptionists",
    },
    {
      icon: "fast-delivery-two",
      text: "Fast Delivery",
    },
    {
      icon: "secure",
      text: "Secure &</br>Confidential",
    },
  ],
  sealMobile: [
    {
      icon: "expert-human",
      text: "Expert Human</br>Transcriptionists",
    },
    {
      icon: "rating",
      text: "4.8 out of 5</br>Aggregate Rating",
    },
  ],
};

export const aboutUscertificationSampleData = {
  imgurl: {
    default: ourStoryImg,
    en: ourStoryImg,
    fr: ourStoryImg,
  },
  title: {
    default: "Our Story",
    en: "Our Story",
    fr: "Our Story",
  },
  highlightWords: {
    default: [" "],
    en: [" "],
    fr: [" "],
  },
  highlightedColor: "yellow",
  description: {
    default:
      "Our company was founded in 2007 by Ofer Tirosh, a global language expert and engineer. We belong to an international group of companies that has grown from serving just a handful of clients to over 95,000+.<br/><br/> Tomedes, our parent company, has served and collaborated with various industries for over 15 years. Now, LexTranscribe seeks to help law firms and businesses maximize their resources with accurate legal transcription services.<br/><br/> Our vision is to be a leading legal transcription company that elevates the standard for transcription with unparalleled precision and genuine client-centered service.",
    en: "Our company was founded in 2007 by Ofer Tirosh, a global language expert and engineer. We belong to an international group of companies that has grown from serving just a handful of clients to over 95,000+.<br/><br/> Tomedes, our parent company, has served and collaborated with various industries for over 15 years. Now, LexTranscribe seeks to help law firms and businesses maximize their resources with accurate legal transcription services.<br/><br/> Our vision is to be a leading legal transcription company that elevates the standard for transcription with unparalleled precision and genuine client-centered service.",
    fr: "Our company was founded in 2007 by Ofer Tirosh, a global language expert and engineer. We belong to an international group of companies that has grown from serving just a handful of clients to over 95,000+.<br/><br/> Tomedes, our parent company, has served and collaborated with various industries for over 15 years. Now, LexTranscribe seeks to help law firms and businesses maximize their resources with accurate legal transcription services.<br/><br/> Our vision is to be a leading legal transcription company that elevates the standard for transcription with unparalleled precision and genuine client-centered service.",
  },
};

export const aboutUsTextRowData = {
  title: {
    default: "What Makes Us<br/> Different",
    en: "What Makes Us<br/> Different",
    fr: "What Makes Us<br/> Different",
  },
  highlightWords: {
    default: ["Different"],
    en: ["Different"],
    fr: ["Different"],
  },
  highlightedColor: "yellow",
  subtitle: {
    default:
      "At LexTranscribe, our team shares a passion for helping you achieve your goals. Our network of skilled transcriptionists gives you the power of 120 languages and accurate transcription services whenever you need them. Because we understand each client is unique, we take the time to customize our services to fit your needs.<br/><br/> Genuine care makes a world of difference. Let us help maximize the value of your time and skills.",
    en: "At LexTranscribe, our team shares a passion for helping you achieve your goals. Our network of skilled transcriptionists gives you the power of 120 languages and accurate transcription services whenever you need them. Because we understand each client is unique, we take the time to customize our services to fit your needs.<br/><br/> Genuine care makes a world of difference. Let us help maximize the value of your time and skills.",
    fr: "At LexTranscribe, our team shares a passion for helping you achieve your goals. Our network of skilled transcriptionists gives you the power of 120 languages and accurate transcription services whenever you need them. Because we understand each client is unique, we take the time to customize our services to fit your needs.<br/><br/> Genuine care makes a world of difference. Let us help maximize the value of your time and skills.",
  },
};

export const aboutUsCtaData = {
  heading: {
    default:
      "<span class='text-3xl'>Ready to learn how we can help you?<span/><br/><span class='text-24px leading-8 block pt-3'>Speak with one of our project managers today.</span>",
    en: "<span class='text-3xl'>Ready to learn how we can help you?<span/><br/><span class='text-24px leading-8 block pt-3'>Speak with one of our project managers today.</span>",
    fr: "<span class='text-3xl'>Ready to learn how we can help you?<span/><br/><span class='text-24px leading-7 block'>Speak with one of our project managers today.</span>",
  },
  text: {
    default: "CONTACT US",
    en: "CONTACT US",
    fr: "CONTACT US",
  },
  href: {
    default: "/contactus",
    en: "/contactus",
    fr: "/contactus",
  },
};

export const ceoMessageData = {
  title: {
    default:
      " Our team cares about each project. The superior quality of transcripts consistently delivered reflects the time and attention invested in them.",
    en: " Our team cares about each project. The superior quality of transcripts consistently delivered reflects the time and attention invested in them.",
    fr: " Our team cares about each project. The superior quality of transcripts consistently delivered reflects the time and attention invested in them.",
  },
  highlightWords: {
    default: [" "],
    en: [" "],
    fr: [" "],
  },
  highlightedColor: "yellow",
  subTitle: {
    default: "MESSAGE FROM THE CEO",
    en: "MESSAGE FROM THE CEO",
    fr: "MESSAGE FROM THE CEO",
  },
  message: {
    default:
      "Our dedication to <span class='font-semibold'>client success</span> sets us apart from other legal transcription agencies. We add value to our clients’ lives by understanding their problems and offering solutions.<br/><br/> The future of legal transcription is full of possibilities. We look forward to helping law firms and businesses reach their full potential.",
    en: "Our dedication to <span class='font-semibold'>client success</span> sets us apart from other legal transcription agencies. We add value to our clients’ lives by understanding their problems and offering solutions.<br/><br/> The future of legal transcription is full of possibilities. We look forward to helping law firms and businesses reach their full potential.",
    fr: "Our dedication to <span class='font-semibold'>client success</span> sets us apart from other legal transcription agencies. We add value to our clients’ lives by understanding their problems and offering solutions.<br/><br/> The future of legal transcription is full of possibilities. We look forward to helping law firms and businesses reach their full potential.",
  },
  name: {
    default: "- Ofer Tirosh, CEO",
    en: "- Ofer Tirosh, CEO",
    fr: "- Ofer Tirosh, CEO",
  },
  ceoImg: ceoImg,
};

export const aboutUscertificationSampleDataTwo = {
  imgurl: {
    default: agencyImg,
    en: agencyImg,
    fr: agencyImg,
  },
  title: {
    default: "Our Transcription Agency Is Devoted To Your Success",
    en: "Our Transcription Agency Is Devoted To Your Success",
    fr: "Our Transcription Agency Is Devoted To Your Success",
  },
  highlightWords: {
    default: ["Success "],
    en: ["Success"],
    fr: ["Success"],
  },
  highlightedColor: "yellow",
  description: {
    default:
      "Renowned institutions trust LexTranscribe for reliable legal transcriptions & 24/7 client care. Our legal transcriptionists speak 120 languages. With decades of combined experience, they specialize in legal transcription for a variety of industries.<br/><br/> Our team provides searchable transcriptions in a variety of formats, which we can customize according to your specifications. We are dedicated to ensuring accuracy and quality with our 100% Satisfaction Guarantee.",
    en: "Renowned institutions trust LexTranscribe for reliable legal transcriptions & 24/7 client care. Our legal transcriptionists speak 120 languages. With decades of combined experience, they specialize in legal transcription for a variety of industries.<br/><br/> Our team provides searchable transcriptions in a variety of formats, which we can customize according to your specifications. We are dedicated to ensuring accuracy and quality with our 100% Satisfaction Guarantee.",
    fr: "Renowned institutions trust LexTranscribe for reliable legal transcriptions & 24/7 client care. Our legal transcriptionists speak 120 languages. With decades of combined experience, they specialize in legal transcription for a variety of industries.<br/><br/> Our team provides searchable transcriptions in a variety of formats, which we can customize according to your specifications. We are dedicated to ensuring accuracy and quality with our 100% Satisfaction Guarantee.",
  },
};

export const doubleColData = {
  title: {
    default: "Our Legal Transcription Company<br> Helps You Succeed",
    en: "Our Legal Transcription Company<br> Helps You Succeed",
    fr: "Our Legal Transcription Company<br> Helps You Succeed",
  },
  highlightWords: {
    default: [" "],
    en: [" "],
    fr: [" "],
  },
  highlightedColor: "yellow",
  subtitle: {
    default:
      "Professionals use legal transcription in a variety of industries, from real estate to law. Our team understands the unique issues you face in the legal and business sectors. So, if you're looking for fast, affordable legal transcripts, LexTranscribe is here to serve you.",
    en: "Professionals use legal transcription in a variety of industries, from real estate to law. Our team understands the unique issues you face in the legal and business sectors. So, if you're looking for fast, affordable legal transcripts, LexTranscribe is here to serve you.",
    fr: "Professionals use legal transcription in a variety of industries, from real estate to law. Our team understands the unique issues you face in the legal and business sectors. So, if you're looking for fast, affordable legal transcripts, LexTranscribe is here to serve you.",
  },
  maindata: [
    {
      id: 0,
      icon: {
        default: "cost-effective",
        en: "cost-effective",
        fr: "cost-effective",
      },
      heading: {
        default: "Cost-Effective Solutions<br /> For Your Law Firm",
        en: "Cost-Effective Solutions<br /> For Your Law Firm",
        fr: "Cost-Effective Solutions<br /> For Your Law Firm",
      },
      maintext: {
        default:
          "Make researching and referencing effortless with searchable legal transcripts. Simply press Ctrl + F, type a keyword into the search box, and each instance of the phrase is highlighted for you. Considering administrative costs and time you’ll save, our legal transcription services virtually pay for themselves.",
        en: "Make researching and referencing effortless with searchable legal transcripts. Simply press Ctrl + F, type a keyword into the search box, and each instance of the phrase is highlighted for you. Considering administrative costs and time you’ll save, our legal transcription services virtually pay for themselves.",
        fr: "Make researching and referencing effortless with searchable legal transcripts. Simply press Ctrl + F, type a keyword into the search box, and each instance of the phrase is highlighted for you. Considering administrative costs and time you’ll save, our legal transcription services virtually pay for themselves.",
      },
    },
    {
      id: 1,
      icon: {
        default: "fast-delivery-three",
        en: "fast-delivery-three",
        fr: "fast-delivery-three",
      },
      heading: {
        default: "Fast Delivery<br /> For Legal Courts & Lawyers",
        en: "Fast Delivery<br /> For Legal Courts & Lawyers",
        fr: "Fast Delivery<br /> For Legal Courts & Lawyers",
      },
      maintext: {
        default:
          "Client demands and impromptu court requests often arise at the last minute. Our accurate legal transcriptionists work in tandem with the latest technology to deliver fast turnaround times while ensuring quality. Prepare for the unexpected with fast, accurate legal transcription at your fingertips.",
        en: "Client demands and impromptu court requests often arise at the last minute. Our accurate legal transcriptionists work in tandem with the latest technology to deliver fast turnaround times while ensuring quality. Prepare for the unexpected with fast, accurate legal transcription at your fingertips.",
        fr: "Client demands and impromptu court requests often arise at the last minute. Our accurate legal transcriptionists work in tandem with the latest technology to deliver fast turnaround times while ensuring quality. Prepare for the unexpected with fast, accurate legal transcription at your fingertips.",
      },
    },
    {
      id: 2,
      icon: {
        default: "collaboration",
        en: "collaboration",
        fr: "collaboration",
      },
      heading: {
        default: "Collaboration Features<br /> For Your Business & Corporation",
        en: "Collaboration Features<br /> For Your Business & Corporation",
        fr: "Collaboration Features<br /> For Your Business & Corporation",
      },
      maintext: {
        default:
          "Don’t lose brilliant ideas during collaboration. LexTranscribe’s features allow you to easily take notes, highlight, and share legal transcripts with your team whether you work for a small business or a corporate legal department. With your legal documents combined into convenient digital files, your team can easily communicate and strategize.",
        en: "Don’t lose brilliant ideas during collaboration. LexTranscribe’s features allow you to easily take notes, highlight, and share legal transcripts with your team whether you work for a small business or a corporate legal department. With your legal documents combined into convenient digital files, your team can easily communicate and strategize.",
        fr: "Don’t lose brilliant ideas during collaboration. LexTranscribe’s features allow you to easily take notes, highlight, and share legal transcripts with your team whether you work for a small business or a corporate legal department. With your legal documents combined into convenient digital files, your team can easily communicate and strategize.",
      },
    },
    {
      id: 3,
      icon: {
        default: "law-enforcement-two",
        en: "law-enforcement-two",
        fr: "law-enforcement-two",
      },
      heading: {
        default:
          "Eliminate Tedious Tasks With<br /> Law Enforcement Transcription",
        en: "Eliminate Tedious Tasks With Law<br /> Enforcement Transcription",
        fr: "Eliminate Tedious Tasks With Law<br /> Enforcement Transcription",
      },
      maintext: {
        default:
          "Transcribing victim or suspect statements is a tedious task, and more than likely, it is not what you dreamed of doing as an investigator or police officer. Our transcribers have worked with police departments throughout the US. Let our experts take the burden of law enforcement transcription off your hands, so you can focus on protecting your community.",
        en: "Transcribing victim or suspect statements is a tedious task, and more than likely, it is not what you dreamed of doing as an investigator or police officer. Our transcribers have worked with police departments throughout the US. Let our experts take the burden of law enforcement transcription off your hands, so you can focus on protecting your community.",
        fr: "Transcribing victim or suspect statements is a tedious task, and more than likely, it is not what you dreamed of doing as an investigator or police officer. Our transcribers have worked with police departments throughout the US. Let our experts take the burden of law enforcement transcription off your hands, so you can focus on protecting your community.",
      },
    },
  ],
};

export const officesLocationData = {
  title: {
    default: "Find us here",
    en: "Find us here",
    fr: "Find us here",
  },
  highlightWords: {
    default: [" "],
    en: [" "],
    fr: [" "],
  },
  highlightedColor: "yellow",
  items: [
    {
      img: {
        default: newYorkImg,
        en: newYorkImg,
        fr: newYorkImg,
      },
      title: {
        default: "United States",
        en: "United States",
        fr: "United States",
      },
      description: {
        default:
          "9450 SW Gemini Dr #34540, Beaverton,<br />OR 97008-7105 <br />Call : +1 985 239 0142",
        en: "9450 SW Gemini Dr #34540, Beaverton,<br />OR 97008-7105 <br />Call : +1 985 239 0142",
        fr: "9450 SW Gemini Dr #34540, Beaverton,<br />OR 97008-7105 <br />Call : +1 985 239 0142",
      },
    },
    {
      img: {
        default: middleEastImg,
        en: middleEastImg,
        fr: middleEastImg,
      },
      title: {
        default: "Middle East",
        en: "Middle East",
        fr: "Middle East",
      },
      description: {
        default:
          "26 HaRokmim st. Azrieli Business Center,<br /> Building C, 7th floor, Holon 5885849, Israel<br /> Call : +972 (0)72 220 0700",
        en: "26 HaRokmim st. Azrieli Business Center,<br /> Building C, 7th floor, Holon 5885849, Israel<br /> Call : +972 (0)72 220 0700",
        fr: "26 HaRokmim st. Azrieli Business Center,<br /> Building C, 7th floor, Holon 5885849, Israel<br /> Call : +972 (0)72 220 0700",
      },
    },
    {
      img: {
        default: europeImg,
        en: europeImg,
        fr: europeImg,
      },
      title: {
        default: "Europe",
        en: "Europe",
        fr: "Europe",
      },
      description: {
        default:
          "International House, 12 Constance St,<br /> London, E16 2DQ<br /> Call: +44 (0)16 1509 6140",
        en: "International House, 12 Constance St,<br /> London, E16 2DQ<br /> Call: +44 (0)16 1509 6140",
        fr: "International House, 12 Constance St,<br /> London, E16 2DQ<br /> Call: +44 (0)16 1509 6140",
      },
    },
  ],
};
// ---------security-and- condfidentiality-------
export const securityHeaderData = {
  title: {
    default: "Security &<br/>Confidentiality",
    en: "Security &<br/>Confidentiality",
    fr: "Security &<br/>Confidentiality",
  },
  description: {
    default:
      "A security breach puts your client at risk and jeopardizes your future. LexTranscribe features data security protocols and a highly trained team safeguarding your information.",
    en: "A security breach puts your client at risk and jeopardizes your future. LexTranscribe features data security protocols and a highly trained team safeguarding your information.",
    fr: "A security breach puts your client at risk and jeopardizes your future. LexTranscribe features data security protocols and a highly trained team safeguarding your information.",
  },
  imgurl: {
    default: securityBanner,
    en: securityBanner,
    fr: securityBanner,
  },
  sealDesktop: [
    {
      icon: "quality-guaranteed",
      text: "Guaranteed</br>Quality & Accuracy",
    },
    {
      icon: "expert-human",
      text: "Expert Human</br>Transcriptionists",
    },
    {
      icon: "fast-delivery-two",
      text: "Fast Delivery",
    },
    {
      icon: "secure",
      text: "Secure &</br>Confidential",
    },
  ],
  sealMobile: [
    {
      icon: "expert-human",
      text: "Expert Human</br>Transcriptionists",
    },
    {
      icon: "rating",
      text: "4.8 out of 5</br>Aggregate Rating",
    },
  ],
};

export const securityRowData = {
  title: {
    default: "Trust Requires<br/> More Than Words",
    en: "Trust Requires<br/> More Than Words",
    fr: "Trust Requires<br/> More Than Words",
  },
  highlightWords: {
    default: ["Trust"],
    en: ["Trust"],
    fr: ["Trust"],
  },
  highlightedColor: "yellow",
  subtitle: {
    default:
      "Anyone can say they’ll protect your security & confidentiality. But will they actually deliver on that promise? Unfortunately, many companies overpromise and underwhelm. Some have all the tech, but their teams haven't invested the time or care into building actionable plans.<br/><br/>At LexTranscribe, our words are backed by action and a team of loyal professionals. Our entire team has completed extensive training in confidentiality & security protocols.<br/><br/> Most importantly, we care about keeping your information safe. We invite you to learn about our commitment to earning and preserving your trust.",
    en: "Anyone can say they’ll protect your security & confidentiality. But will they actually deliver on that promise? Unfortunately, many companies overpromise and underwhelm. Some have all the tech, but their teams haven't invested the time or care into building actionable plans.<br/><br/>At LexTranscribe, our words are backed by action and a team of loyal professionals. Our entire team has completed extensive training in confidentiality & security protocols.<br/><br/> Most importantly, we care about keeping your information safe. We invite you to learn about our commitment to earning and preserving your trust.",
    fr: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim.",
  },
};

export const securityData2 = {
  title: {
    default: "Experience The Highest Level Of Security",
    en: "Experience The Highest Level Of Security",
    fr: "Experience The Highest Level Of Security",
  },
  highlightWords: {
    default: [" "],
    en: [" "],
    fr: [" "],
  },
  highlightedColor: "yellow",
  subtitle: {
    default:
      "Handling sensitive client information requires the highest level of security and a team prepared to cover every angle. LexTranscribe implements a four-point security protocol.",
    en: "Handling sensitive client information requires the highest level of security and a team prepared to cover every angle. LexTranscribe implements a four-point security protocol.",
    fr: "Handling sensitive client information requires the highest level of security and a team prepared to cover every angle. LexTranscribe implements a four-point security protocol.",
  },
  maindata: [
    {
      id: 0,
      icon: {
        default: "security-large",
        en: "security-large",
        fr: "translate",
      },
      heading: {
        default: "Take Data Protection To The Next Level",
        en: "Take Data Protection To The Next Level",
        fr: "Take Data Protection To The Next Level",
      },
      maintext: {
        default:
          "Malware and virus attacks can compromise your files. Our secure network protects your data from the initial transmission of your audio files through processing and storing your legal transcript.",
        en: "Malware and virus attacks can compromise your files. Our secure network protects your data from the initial transmission of your audio files through processing and storing your legal transcript.",
        fr: "Malware and virus attacks can compromise your files. Our secure network protects your data from the initial transmission of your audio files through processing and storing your legal transcript.",
      },
    },
    {
      id: 1,
      icon: {
        default: "encryption",
        en: "encryption",
        fr: "translate",
      },
      heading: {
        default: "Safeguard Your Files With Data Encryption",
        en: "Safeguard Your Files With Data Encryption",
        fr: "Safeguard Your Files With Data Encryption",
      },
      maintext: {
        default:
          "Cybercriminals can intercept your legal files for ransom, threatening to leak your information and demand money. Our platform features HTTPS with SSL encryption to prevent identity theft and ransomware.",
        en: "Cybercriminals can intercept your legal files for ransom, threatening to leak your information and demand money. Our platform features HTTPS with SSL encryption to prevent identity theft and ransomware.",
        fr: "Cybercriminals can intercept your legal files for ransom, threatening to leak your information and demand money. Our platform features HTTPS with SSL encryption to prevent identity theft and ransomware.",
      },
    },
    {
      id: 2,
      icon: {
        default: "data-retention",
        en: "data-retention",
        fr: "translate",
      },
      heading: {
        default:
          "Maintain Control With Data Retention <span class='block invisible'>invisible</span>",
        en: "Maintain Control With Data Retention <span class='block invisible'>invisible</span>",
        fr: "Maintain Control With Data Retention",
      },
      maintext: {
        default:
          "Some legal transcription companies sell your information without your permission. At LexTranscribe, you maintain complete control of your data. We only store or delete files at your request.",
        en: "Some legal transcription companies sell your information without your permission. At LexTranscribe, you maintain complete control of your data. We only store or delete files at your request.",
        fr: "Some legal transcription companies sell your information without your permission. At LexTranscribe, you maintain complete control of your data. We only store or delete files at your request.",
      },
    },
    {
      id: 3,
      icon: {
        default: "security-management",
        en: "security-management",
        fr: "translate",
      },
      heading: {
        default: "Let Our Security Management Protect You",
        en: "Let Our Security Management Protect You",
        fr: "Let Our Security Management Protect You",
      },
      maintext: {
        default:
          "Don't wait until your security is under attack. Our Data Protection Officers have the experience to identify and mitigate threats in advance. We prevent security attacks before they happen.",
        en: "Don't wait until your security is under attack. Our Data Protection Officers have the experience to identify and mitigate threats in advance. We prevent security attacks before they happen.",
        fr: "Don't wait until your security is under attack. Our Data Protection Officers have the experience to identify and mitigate threats in advance. We prevent security attacks before they happen.",
      },
    },
  ],
};

export const threeColData = {
  title: {
    default: "We’re Committed To Our<br/> Confidentiality Agreement",
    en: "We’re Committed To Our<br/> Confidentiality Agreement",
    fr: "We’re Committed To Our<br/> Confidentiality Agreement",
  },
  subtitle: {
    default:
      "A careless transcription company may leak your confidential information. At LexTranscribe, what you share stays with us. We build lasting professional relationships on mutual trust and confidentiality.",
    en: "A careless transcription company may leak your confidential information. At LexTranscribe, what you share stays with us. We build lasting professional relationships on mutual trust and confidentiality.",
    fr: "A careless transcription company may leak your confidential information. At LexTranscribe, what you share stays with us. We build lasting professional relationships on mutual trust and confidentiality.",
  },
  items: [
    {
      id: 1,
      icon: {
        default: "confidentiality",
        en: "confidentiality",
        fr: "translate",
      },
      heading: {
        default: "Our Team Understands the Importance of Confidentiality",
        en: "Our Team Understands the Importance of Confidentiality",
        fr: "Non-Disclosure Agreement",
      },
      description: {
        default:
          "Some companies don't even bother with NDAs. Our team members are fully vetted and sign Non-Disclosure Agreements. They also complete training to ensure these agreements are understood and taken seriously.",
        en: "Some companies don't even bother with NDAs. Our team members are fully vetted and sign Non-Disclosure Agreements. They also complete training to ensure these agreements are understood and taken seriously.",
        fr: "Some companies don't even bother with NDAs. Our team members are fully vetted and sign Non-Disclosure Agreements. They also complete training to ensure these agreements are understood and taken seriously.",
      },
    },
    {
      id: 2,
      icon: {
        default: "unauthorized",
        en: "unauthorized",
        fr: "translate",
      },
      heading: {
        default: "Prevent Unauthorized Disclosure",
        en: "Prevent Unauthorized Disclosure",
        fr: "",
      },
      description: {
        default:
          "User errors and lack of training put your confidentiality at risk. You don't want sensitive information disclosed to unauthorized individuals. Our team adheres to strict procedures for handling your information.",
        en: "User errors and lack of training put your confidentiality at risk. You don't want sensitive information disclosed to unauthorized individuals. Our team adheres to strict procedures for handling your information.",
        fr: "User errors and lack of training put your confidentiality at risk. You don't want sensitive information disclosed to unauthorized individuals. Our team adheres to strict procedures for handling your information.",
      },
    },
    {
      id: 3,
      icon: {
        default: "technical-controls",
        en: "technical-controls",
        fr: "translate",
      },
      heading: {
        default: "Technical Controls Designed To Protect Your Information",
        en: "Technical Controls Designed To Protect Your Information",
        fr: "Technical Controls Designed To Protect Your Information",
      },
      description: {
        default:
          "Don't let your confidentiality fall into the wrong hands. With technical controls, including multi-factor authentication and file access logs, we prevent insider & outsider security breaches before it's too late.",
        en: "Don't let your confidentiality fall into the wrong hands. With technical controls, including multi-factor authentication and file access logs, we prevent insider & outsider security breaches before it's too late.",
        fr: "Don't let your confidentiality fall into the wrong hands. With technical controls, including multi-factor authentication and file access logs, we prevent insider & outsider security breaches before it's too late.",
      },
    },
  ],
};

export const arbitrationpageData = {
  title: {
    default: "Arbitration Transcription Gives You Access To The Facts",
    en: "Arbitration Transcription Gives You Access To The Facts",
    fr: "Arbitration Transcription Gives You Access To The Facts",
  },
  description: {
    default:
      "It’s easy to forget crucial details during the back and forth questioning of arbitration. LexTranscribe provides accurate arbitration transcription services to law firms and legal institutions throughout the US. Our arbitration transcriptionists give you access to a searchable verbatim record so you can build a strong argument based on the facts.",
    en: "It’s easy to forget crucial details during the back and forth questioning of arbitration. LexTranscribe provides accurate arbitration transcription services to law firms and legal institutions throughout the US. Our arbitration transcriptionists give you access to a searchable verbatim record so you can build a strong argument based on the facts.",
    fr: "It’s easy to forget crucial details during the back and forth questioning of arbitration. LexTranscribe provides accurate arbitration transcription services to law firms and legal institutions throughout the US. Our arbitration transcriptionists give you access to a searchable verbatim record so you can build a strong argument based on the facts.",
  },
  btnText: {
    default: "GET STARTED",
    en: "GET STARTED",
    fr: "GET STARTED",
  },
  imgurl: {
    default: arbitrationBanner,
    en: arbitrationBanner,
    fr: arbitrationBanner,
  },
  sealDesktop: [
    {
      icon: "quality-guaranteed",
      text: "Guaranteed</br>Quality & Accuracy",
    },
    {
      icon: "expert-human",
      text: "Expert Human</br>Transcriptionists",
    },
    {
      icon: "fast-delivery-two",
      text: "Fast Delivery",
    },
    {
      icon: "secure",
      text: "Secure &</br>Confidential",
    },
  ],
  sealMobile: [
    {
      icon: "expert-human",
      text: "Expert Human</br>Transcriptionists",
    },
    {
      icon: "rating",
      text: "4.8 out of 5</br>Aggregate Rating",
    },
  ],
};
export const arbitrationpageData2 = {
  title: {
    default:
      "Arbitration Transcription Makes<br/> Your Hearing More Cost-Efficient",
    en: "Arbitration Transcription Makes<br/> Your Hearing More Cost-Efficient",
    fr: "Arbitration Transcription Makes<br/> Your Hearing More Cost-Efficient",
  },
  highlightWords: {
    default: ["Arbitration Transcription"],
    en: ["Arbitration Transcription"],
    fr: ["Arbitration Transcription"],
  },
  highlightedColor: "yellow",
  subtitle: {
    default:
      "Don’t waste time with stenographers and court reporters. Arbitration transcription doesn’t require pausing during the hearing or a long wait for production. Whether you’re a third-party arbitration body, arbitrator, lawyer, or professional, LexTranscribe provides accurate arbitration transcripts <span class='font-semibold'>saving you time and money</span> on your terms.",
    en: "Don’t waste time with stenographers and court reporters. Arbitration transcription doesn’t require pausing during the hearing or a long wait for production. Whether you’re a third-party arbitration body, arbitrator, lawyer, or professional, LexTranscribe provides accurate arbitration transcripts <span class='font-semibold'>saving you time and money</span> on your terms.",
    fr: "Don’t waste time with stenographers and court reporters. Arbitration transcription doesn’t require pausing during the hearing or a long wait for production. Whether you’re a third-party arbitration body, arbitrator, lawyer, or professional, LexTranscribe provides accurate arbitration transcripts <span class='font-semibold'>saving you time and money</span  on your terms.",
  },
};
export const arbitrationpageTwoColGridWithOrderData = {
  title: {
    default: "Why Choose Our Arbitration<br/> Transcription Services?",
    en: "Why Choose Our Arbitration<br/> Transcription Services?",
    fr: "Why Choose Our Arbitration<br/> Transcription Services?",
  },
  highlightWords: {
    default: [" "],
    en: [" "],
    fr: [" "],
  },
  highlightedColor: "yellow",
  subTitle: {
    default:
      "Other agencies simply don’t have the skills or time to provide the attention to detail that we do. When you choose LexTranscibe, we ensure our arbitration transcription services add value to your work. You’ll receive quality, accurate arbitration transcripts & exceptional service.",
    en: "Other agencies simply don’t have the skills or time to provide the attention to detail that we do. When you choose LexTranscibe, we ensure our arbitration transcription services add value to your work. You’ll receive quality, accurate arbitration transcripts & exceptional service.",
    fr: "Other agencies simply don’t have the skills or time to provide the attention to detail that we do. When you choose LexTranscibe, we ensure our arbitration transcription services add value to your work. You’ll receive quality, accurate arbitration transcripts & exceptional service.",
  },
  items: [
    {
      image: {
        default: whyImg1,
        en: whyImg1,
        fr: whyImg1,
      },
      mainData: [
        {
          title: {
            default:
              "We Deliver The Highest-Quality Arbitration Transcription Services In Every Setting",
            en: "We Deliver The Highest-Quality Arbitration Transcription Services In Every Setting",
            fr: "We Deliver The Highest-Quality Arbitration Transcription Services In Every Setting",
          },
          highlightWords: {
            default: ["Highest-Quality"],
            en: ["Highest-Quality"],
            fr: ["Highest-Quality"],
          },
          highlightedColor: "yellow",
          description: {
            default:
              "If you’re facing mandated or court-ordered arbitration, you need skilled arbitration transcriptionists who deliver consistent quality and formatting according to your requirements. We have experience working with law firms, courts, corporations, & third-party arbitration bodies.",
            en: "If you’re facing mandated or court-ordered arbitration, you need skilled arbitration transcriptionists who deliver consistent quality and formatting according to your requirements. We have experience working with law firms, courts, corporations, & third-party arbitration bodies.",
            fr: "If you’re facing mandated or court-ordered arbitration, you need skilled arbitration transcriptionists who deliver consistent quality and formatting according to your requirements. We have experience working with law firms, courts, corporations, & third-party arbitration bodies.",
          },
        },
        {
          title: {
            default: "We Accept & Transcribe Arbitrations In Any File Format",
            en: "We Accept & Transcribe Arbitrations In Any File Format",
            fr: "We Accept & Transcribe Arbitrations In Any File Format",
          },
          highlightWords: {
            default: ["Any File Format"],
            en: ["Any File Format"],
            fr: ["Any File Format"],
          },
          highlightedColor: "yellow",
          description: {
            default:
              "Whether you need a standard or custom format, we’ll deliver your transcripts according to your instructions. We transcribe in-person and remote arbitration in over 50 digital file types including but not limited to:",
            en: "Whether you need a standard or custom format, we’ll deliver your transcripts according to your instructions. We transcribe in-person and remote arbitration in over 50 digital file types including but not limited to:",
            fr: "Whether you need a standard or custom format, we’ll deliver your transcripts according to your instructions. We transcribe in-person and remote arbitration in over 50 digital file types including but not limited to:",
          },
          list: [
            {
              text: {
                default: "MP3 & MP4",
                en: "MP3 & MP4",
                fr: "MP3 & MP4",
              },
            },
            {
              text: {
                default: "Windows Media Audio - WMA",
                en: "Windows Media Audio - WMA",
                fr: "Windows Media Audio - WMA",
              },
            },
            {
              text: {
                default: "Waveform Audio - WAV",
                en: "Waveform Audio - WAV",
                fr: "Waveform Audio - WAV",
              },
            },
            {
              text: {
                default: "Audio Interchange File - AIFF",
                en: "Audio Interchange File - AIFF",
                fr: "Audio Interchange File - AIFF",
              },
            },
            {
              text: {
                default: "Digital Speech<br>Standard - DSS",
                en: "Digital Speech<br>Standard - DSS",
                fr: "Digital Speech<br>Standard - DSS",
              },
            },
            {
              text: {
                default: "Quick Time Movie - MOV",
                en: "Quick Time Movie - MOV",
                fr: "Quick Time Movie - MOV",
              },
            },
          ],
        },
      ],
    },
    {
      image: {
        default: whyImg2,
        en: whyImg2,
        fr: whyImg2,
      },

      mainData: [
        {
          title: {
            default: "We Support Your Success After Transcription",
            en: "We Support Your Success After Transcription",
            fr: "We Support Your Success After Transcription",
          },
          highlightWords: {
            default: ["Support Your Success"],
            en: ["Support Your Success"],
            fr: ["Support Your Success"],
          },
          highlightedColor: "yellow",
          description: {
            default:
              "Many companies don’t invest the effort to build lasting client relationships. With arbitration transcription services, you receive one year of postproduction support after project delivery, which includes subtitles or translated captions for the arbitration video.",
            en: "Many companies don’t invest the effort to build lasting client relationships. With arbitration transcription services, you receive one year of postproduction support after project delivery, which includes subtitles or translated captions for the arbitration video.",
            fr: "Many companies don’t invest the effort to build lasting client relationships. With arbitration transcription services, you receive one year of postproduction support after project delivery, which includes subtitles or translated captions for the arbitration video.",
          },
        },
        {
          title: {
            default: "We Safeguard Your Data Security & Confidentiality",
            en: "We Safeguard Your Data Security & Confidentiality",
            fr: "We Safeguard Your Data Security & Confidentiality",
          },
          highlightWords: {
            default: ["Data Security"],
            en: ["Data Security"],
            fr: ["Data Security"],
          },
          highlightedColor: "yellow",
          description: {
            default:
              "Inexperienced companies put you at risk for identity theft or worse. Our team values your data security and confidentiality. Our SSL encryption & strict security protocols keep your privileged information safe during transmission, processing, and storage.",
            en: "Inexperienced companies put you at risk for identity theft or worse. Our team values your data security and confidentiality. Our SSL encryption & strict security protocols keep your privileged information safe during transmission, processing, and storage.",
            fr: "Inexperienced companies put you at risk for identity theft or worse. Our team values your data security and confidentiality. Our SSL encryption & strict security protocols keep your privileged information safe during transmission, processing, and storage.",
          },
        },
      ],
    },
    {
      image: {
        default: whyImg3,
        en: whyImg3,
        fr: whyImg3,
      },

      mainData: [
        {
          title: {
            default: "You Can Rely On Our Fast Turnaround Times",
            en: "You Can Rely On Our Fast Turnaround Times",
            fr: "You Can Rely On Our Fast Turnaround Times",
          },
          highlightWords: {
            default: ["Fast Turnaround"],
            en: ["Fast Turnaround"],
            fr: ["Fast Turnaround"],
          },
          highlightedColor: "yellow",
          description: {
            default:
              "You can’t waste time waiting on transcripts from court reporters. LexTranscribe understands the urgency of your arbitration transcripts. Our team can produce accurate arbitration transcripts even under tight time restrictions. We deliver on your schedule.",
            en: "You can’t waste time waiting on transcripts from court reporters. LexTranscribe understands the urgency of your arbitration transcripts. Our team can produce accurate arbitration transcripts even under tight time restrictions. We deliver on your schedule.",
            fr: "You can’t waste time waiting on transcripts from court reporters. LexTranscribe understands the urgency of your arbitration transcripts. Our team can produce accurate arbitration transcripts even under tight time restrictions. We deliver on your schedule.",
          },
        },
        {
          title: {
            default: "Scalable Solutions For You Large Volume Needs",
            en: "Scalable Solutions For You Large Volume Needs",
            fr: "Scalable Solutions For You Large Volume Needs",
          },
          highlightWords: {
            default: ["Scalable Solutions"],
            en: ["Scalable Solutions"],
            fr: ["Scalable Solutions"],
          },
          highlightedColor: "yellow",
          description: {
            default:
              "Large volumes may seem overwhelming. But LexTranscribe transforms them into searchable text files with ease. We can handle all your transcription needs, both big & small. Let us help tackle backlogs, satisfy strict deadlines, & increase cost-effectiveness.",
            en: "Large volumes may seem overwhelming. But LexTranscribe transforms them into searchable text files with ease. We can handle all your transcription needs, both big & small. Let us help tackle backlogs, satisfy strict deadlines, & increase cost-effectiveness.",
            fr: "Large volumes may seem overwhelming. But LexTranscribe transforms them into searchable text files with ease. We can handle all your transcription needs, both big & small. Let us help tackle backlogs, satisfy strict deadlines, & increase cost-effectiveness.",
          },
        },
      ],
    },
  ],
};

export const arbitrationFrequentlyData = {
  title: {
    default: "Frequently Asked Questions",
    en: "Frequently Asked Questions",
    fr: "Frequently Asked Questions",
  },
  accordionItems: [
    {
      heading: {
        default: "What are the two types of arbitration?",
        en: "What are the two types of arbitration?",
        fr: "What are the two types of arbitration?",
      },
      description: {
        default:
          "In the US, arbitration is classified as either binding or nonbinding. Under binding arbitration, the arbitrator’s decision is final, and neither party can challenge it afterward. However, nonbinding arbitration allows for either party to challenge the ruling in court.",
        en: "In the US, arbitration is classified as either binding or nonbinding. Under binding arbitration, the arbitrator’s decision is final, and neither party can challenge it afterward. However, nonbinding arbitration allows for either party to challenge the ruling in court.",
        fr: "In the US, arbitration is classified as either binding or nonbinding. Under binding arbitration, the arbitrator’s decision is final, and neither party can challenge it afterward. However, nonbinding arbitration allows for either party to challenge the ruling in court.",
      },
    },
    {
      heading: {
        default: "Will the type of arbitration matter for my transcription?",
        en: "Will the type of arbitration matter for my transcription?",
        fr: "Will the type of arbitration matter for my transcription?",
      },
      description: {
        default:
          "No, whether your arbitration is binding or nonbinding, we transcribe within our full capacity. We provide certified transcripts, and if you foresee the need to use them in court, they’re fully admissible.",
        en: "No, whether your arbitration is binding or nonbinding, we transcribe within our full capacity. We provide certified transcripts, and if you foresee the need to use them in court, they’re fully admissible.",
        fr: "No, whether your arbitration is binding or nonbinding, we transcribe within our full capacity. We provide certified transcripts, and if you foresee the need to use them in court, they’re fully admissible.",
      },
    },
    {
      heading: {
        default: "Do you have transcriptionists for court-ordered arbitration?",
        en: "Do you have transcriptionists for court-ordered arbitration?",
        fr: "Do you have transcriptionists for court-ordered arbitration?",
      },
      description: {
        default:
          "Yes, our transcriptionists have collaborated with state & local courts, law firms, legal institutions, & third-party arbitrators throughout the US. Rest assured we’ll deliver accurate, fully-certified transcripts of your video or audio files according to the court’s requirements.",
        en: "Yes, our transcriptionists have collaborated with state & local courts, law firms, legal institutions, & third-party arbitrators throughout the US. Rest assured we’ll deliver accurate, fully-certified transcripts of your video or audio files according to the court’s requirements.",
        fr: "Yes, our transcriptionists have collaborated with state & local courts, law firms, legal institutions, & third-party arbitrators throughout the US. Rest assured we’ll deliver accurate, fully-certified transcripts of your video or audio files according to the court’s requirements.",
      },
    },
    {
      heading: {
        default: "How soon can you deliver the arbitration transcription?",
        en: "How soon can you deliver the arbitration transcription?",
        fr: "How soon can you deliver the arbitration transcription?",
      },
      description: {
        default:
          "LexTranscibe delivers your arbitration transcripts according to your timeline, even when you have urgent deadlines. We offer three convenient options: fast transcription, best price transcription, & custom transcription options. <a href='/contactus' class='hover:text-yellow underline'>Choose the one that fits your needs</a>.",
        en: "LexTranscibe delivers your arbitration transcripts according to your timeline, even when you have urgent deadlines. We offer three convenient options: fast transcription, best price transcription, & custom transcription options. <a href='/contactus' class='hover:text-yellow underline font-medium'>Choose the one that fits your needs</a>.",
        fr: "LexTranscibe delivers your arbitration transcripts according to your timeline, even when you have urgent deadlines. We offer three convenient options: fast transcription, best price transcription, & custom transcription options. <a href='/contactus' class='hover:text-yellow underline'>Choose the one that fits your needs</a>.",
      },
    },
  ],
};
export const ArbitrationCtaData = {
  heading: {
    default:
      "Discover fast, accurate arbitration transcription near you today.",
    en: "Discover fast, accurate arbitration transcription near you today.",
    fr: "Discover fast, accurate arbitration transcription near you today.",
  },
  text: {
    default: "CONTACT US",
    en: "CONTACT US",
    fr: "CONTACT US",
  },
  href: {
    default: "/contactus",
    en: "/contactus",
    fr: "/contactus",
  },
};
export const Arbitrationdata = {
  title: {
    default:
      "Arbitration Transcriptionists In Major US Cities, Ready To Help You",
    en: "Arbitration Transcriptionists In Major US Cities, Ready To Help You",
    fr: "Arbitration Transcriptionists In Major US Cities, Ready To Help You",
  },
  highlightWords: {
    default: ["Arbitration Transcriptionists"],
    en: ["Arbitration Transcriptionists"],
    fr: ["Arbitration Transcriptionists"],
  },
  highlightedColor: "yellow",
  description: {
    default:
      "LexTranscribe provides arbitration transcripts for law firms & legal institutions in all major US cities. Our arbitration transcriptionists have extensive experience navigating US laws and regulations. Get court-recognized transcripts in the US.",
    en: "LexTranscribe provides arbitration transcripts for law firms & legal institutions in all major US cities. Our arbitration transcriptionists have extensive experience navigating US laws and regulations. Get court-recognized transcripts in the US.",
    fr: "LexTranscribe provides arbitration transcripts for law firms & legal institutions in all major US cities. Our arbitration transcriptionists have extensive experience navigating US laws and regulations. Get court-recognized transcripts in the US.",
  },
};
export const ArbitrationFormData = {
  title: {
    default: "Get the fast, precise arbitration transcription you need now.",
    en: "Get the fast, precise arbitration transcription you need now.",
    fr: "Get the fast, precise arbitration transcription you need now.",
  },
  subtitle: {
    default: "*By submitting, you agree to LexTranscribe's Privacy Policy.",
    en: "*By submitting, you agree to LexTranscribe's Privacy Policy.",
    fr: "*By submitting, you agree to LexTranscribe's Privacy Policy.",
  },
  placeholder: {
    name: {
      default: "Name",
      en: "Name",
      fr: "Name",
    },
    email: {
      default: "Email Address",
      en: "Email Address",
      fr: "Email Address",
    },
  },
  btnText: {
    default: "SUBMIT",
    en: "SUBMIT",
    fr: "SUBMIT",
  },
};

export const curttitledata = {
  title: {
    default: "Court Transcription Customized To Your Legal Needs",
    en: "Court Transcription Customized To Your Legal Needs",
    fr: "Court Transcription Customized To Your Legal Needs",
  },
  description: {
    default:
      "Many court transcription companies promise the moon and stars but never deliver. LexTranscribe understands the importance of accuracy & precision. We deliver the highest quality court transcription to law firms, prosecutors, juries, and judges throughout the US. Keep the facts on your side. Get the precise court transcription services you need.",
    en: "Many court transcription companies promise the moon and stars but never deliver. LexTranscribe understands the importance of accuracy & precision. We deliver the highest quality court transcription to law firms, prosecutors, juries, and judges throughout the US. Keep the facts on your side. Get the precise court transcription services you need.",
    fr: "Many court transcription companies promise the moon and stars but never deliver. LexTranscribe understands the importance of accuracy & precision. We deliver the highest quality court transcription to law firms, prosecutors, juries, and judges throughout the US. Keep the facts on your side. Get the precise court transcription services you need.",
  },
  btnText: {
    default: "GET STARTED",
    en: "GET STARTED",
    fr: "GET STARTED",
  },
  imgurl: {
    default: courtBanner,
    en: courtBanner,
    fr: courtBanner,
  },
  sealDesktop: [
    {
      icon: "quality-guaranteed",
      text: "Guaranteed</br>Quality & Accuracy",
    },
    {
      icon: "expert-human",
      text: "Expert Human</br>Transcriptionists",
    },
    {
      icon: "fast-delivery-two",
      text: "Fast Delivery",
    },
    {
      icon: "secure",
      text: "Secure &</br>Confidential",
    },
  ],
  sealMobile: [
    {
      icon: "expert-human",
      text: "Expert Human</br>Transcriptionists",
    },
    {
      icon: "rating",
      text: "4.8 out of 5</br>Aggregate Rating",
    },
  ],
};

export const curtpageData2 = {
  title: {
    default: "Court Transcription Services<br/> To Help Your Legal Team",
    en: "Court Transcription Services<br/> To Help Your Legal Team",
    fr: "Court Transcription Services<br/> To Help Your Legal Team",
  },
  highlightWords: {
    default: ["Court Transcription"],
    en: ["Court Transcription"],
    fr: ["Court Transcription"],
  },
  highlightedColor: "yellow",
  subtitle: {
    default:
      "You don’t have time to note everything during court proceedings. You must keep your attention on the tone of the courtroom. Let our skilled court transcription team transcribe everything for you. So, your legal team can prepare for the case ahead.",
    en: "You don’t have time to note everything during court proceedings. You must keep your attention on the tone of the courtroom. Let our skilled court transcription team transcribe everything for you. So, your legal team can prepare for the case ahead.",
    fr: "You don’t have time to note everything during court proceedings. You must keep your attention on the tone of the courtroom. Let our skilled court transcription team transcribe everything for you. So, your legal team can prepare for the case ahead.",
  },
};
export const curtpageTwoColGridWithOrderData = {
  title: {
    default: "Why Choose Us Our Court Transcription Services?",
    en: "Why Choose Us Our Court Transcription Services?",
    fr: "Why Choose Us Our Court Transcription Services?",
  },
  highlightWords: {
    default: [" "],
    en: [" "],
    fr: [" "],
  },
  highlightedColor: "yellow",
  subTitle: {
    default:
      "Working with the wrong team could spell disaster for your legal strategy. At LexTranscribe, you’re supported by a legal transcription team with extensive experience in court proceedings. Furthermore, you’ll receive comprehensive court transcription services, 24/7 service, and genuine care.",
    en: "Working with the wrong team could spell disaster for your legal strategy. At LexTranscribe, you’re supported by a legal transcription team with extensive experience in court proceedings. Furthermore, you’ll receive comprehensive court transcription services, 24/7 service, and genuine care.",
    fr: "Working with the wrong team could spell disaster for your legal strategy. At LexTranscribe, you’re supported by a legal transcription team with extensive experience in court proceedings. Furthermore, you’ll receive comprehensive court transcription services, 24/7 service, and genuine care.",
  },
  items: [
    {
      image: {
        default: whyImg1,
        en: whyImg1,
        fr: whyImg1,
      },
      mainData: [
        {
          title: {
            default: "We Connect You With A Certified Court Transcriptionist",
            en: "We Connect You With A Certified Court Transcriptionist",
            fr: "We Connect You With A Certified Court Transcriptionist",
          },
          highlightWords: {
            default: ["Court Transcriptionist"],
            en: ["Court Transcriptionist"],
            fr: ["Court Transcriptionist"],
          },
          highlightedColor: "yellow",
          description: {
            default:
              "Don’t trust your court transcription to computers or unqualified court transcribers. We’ll connect you with a certified court transcriptionist who understands the legal language spoken in your specialty. We have the expertise & experience you need.",
            en: "Don’t trust your court transcription to computers or unqualified court transcribers. We’ll connect you with a certified court transcriptionist who understands the legal language spoken in your specialty. We have the expertise & experience you need.",
            fr: "Don’t trust your court transcription to computers or unqualified court transcribers. We’ll connect you with a certified court transcriptionist who understands the legal language spoken in your specialty. We have the expertise & experience you need.",
          },
        },
        {
          title: {
            default: "We Transcribe Court Proceedings With Precision & Skill",
            en: "We Transcribe Court Proceedings With Precision & Skill",
            fr: "We Transcribe Court Proceedings With Precision & Skill",
          },
          highlightWords: {
            default: ["Transcribe Court Proceedings"],
            en: ["Transcribe Court Proceedings"],
            fr: ["Transcribe Court Proceedings"],
          },
          highlightedColor: "yellow",
          description: {
            default:
              "We’ll deliver your court transcripts customized to your specifications. To ensure flexibility, we transcribe recorded court proceedings, jury trials, appeals, hearings, sentencing, and other court matters. We also accept virtually any audio & video file type for transcription, including but not limited to:",
            en: "We’ll deliver your court transcripts customized to your specifications. To ensure flexibility, we transcribe recorded court proceedings, jury trials, appeals, hearings, sentencing, and other court matters. We also accept virtually any audio & video file type for transcription, including but not limited to:",
            fr: "We’ll deliver your court transcripts customized to your specifications. To ensure flexibility, we transcribe recorded court proceedings, jury trials, appeals, hearings, sentencing, and other court matters. We also accept virtually any audio & video file type for transcription, including but not limited to:",
          },
          list: [
            {
              text: {
                default: "MP3 & MP4",
                en: "MP3 & MP4",
                fr: "MP3 & MP4",
              },
            },
            {
              text: {
                default: "Windows Media Audio - WMA",
                en: "Windows Media Audio - WMA",
                fr: "Windows Media Audio - WMA",
              },
            },
            {
              text: {
                default: "Waveform Audio - WAV",
                en: "Waveform Audio - WAV",
                fr: "Waveform Audio - WAV",
              },
            },
            {
              text: {
                default: "Audio Interchange File - AIFF",
                en: "Audio Interchange File - AIFF",
                fr: "Audio Interchange File - AIFF",
              },
            },
            {
              text: {
                default: "Digital Speech<br>Standard - DSS",
                en: "Digital Speech<br>Standard - DSS",
                fr: "Digital Speech<br>Standard - DSS",
              },
            },
            {
              text: {
                default: "Quick Time Movie - MOV",
                en: "Quick Time Movie - MOV",
                fr: "Quick Time Movie - MOV",
              },
            },
          ],
        },
      ],
    },
    {
      image: {
        default: whyImg2,
        en: whyImg2,
        fr: whyImg2,
      },

      mainData: [
        {
          title: {
            default: "We Ensure Accurate Courtroom Transcription",
            en: "We Ensure Accurate Courtroom Transcription",
            fr: "We Ensure Accurate Courtroom Transcription",
          },
          highlightWords: {
            default: ["Ensure"],
            en: ["Ensure"],
            fr: ["Ensure"],
          },
          highlightedColor: "yellow",
          description: {
            default:
              "Accurate court transcripts eliminate confusion, and it’s crucial to your success. We implement rigorous quality standards, including multiple proofreading and quality checks, to ensure your transcript’s accuracy.",
            en: "Accurate court transcripts eliminate confusion, and it’s crucial to your success. We implement rigorous quality standards, including multiple proofreading and quality checks, to ensure your transcript’s accuracy.",
            fr: "Accurate court transcripts eliminate confusion, and it’s crucial to your success. We implement rigorous quality standards, including multiple proofreading and quality checks, to ensure your transcript’s accuracy.",
          },
        },
        {
          title: {
            default:
              "We Eliminate Vulnerabilities With Strict Data Security & Confidentiality Protocols",
            en: "We Eliminate Vulnerabilities With Strict Data Security & Confidentiality Protocols",
            fr: "We Eliminate Vulnerabilities With Strict Data Security & Confidentiality Protocols",
          },
          highlightWords: {
            default: ["Eliminate"],
            en: ["Eliminate"],
            fr: ["Eliminate"],
          },
          highlightedColor: "yellow",
          description: {
            default:
              "Identity thieves and hackers would love to get their hands on your confidential information. Our Data Security Team works around the clock to ensure that doesn’t happen. With SSL encryption & advanced security protocols, we keep your information safe.",
            en: "Identity thieves and hackers would love to get their hands on your confidential information. Our Data Security Team works around the clock to ensure that doesn’t happen. With SSL encryption & advanced security protocols, we keep your information safe.",
            fr: "Identity thieves and hackers would love to get their hands on your confidential information. Our Data Security Team works around the clock to ensure that doesn’t happen. With SSL encryption & advanced security protocols, we keep your information safe.",
          },
        },
      ],
    },
    {
      image: {
        default: whyImg3,
        en: whyImg3,
        fr: whyImg3,
      },

      mainData: [
        {
          title: {
            default:
              "Even Our Standard Transcription Is Faster Than Court Reporters:",
            en: "Even Our Standard Transcription Is Faster Than Court Reporters:",
            fr: "Even Our Standard Transcription Is Faster Than Court Reporters:",
          },
          highlightWords: {
            default: ["Faster Than Court Reporters:"],
            en: ["Faster Than Court Reporters:"],
            fr: ["Faster Than Court Reporters:"],
          },
          highlightedColor: "yellow",
          description: {
            default:
              "When court reporters or other court transcription companies finally begin transcribing, you may not even need court transcription services. LexTranscribe delivers court-certified transcripts as soon as you need them—not later. 100% Quality Guaranteed.",
            en: "When court reporters or other court transcription companies finally begin transcribing, you may not even need court transcription services. LexTranscribe delivers court-certified transcripts as soon as you need them—not later. 100% Quality Guaranteed.",
            fr: "When court reporters or other court transcription companies finally begin transcribing, you may not even need court transcription services. LexTranscribe delivers court-certified transcripts as soon as you need them—not later. 100% Quality Guaranteed.",
          },
        },
        {
          title: {
            default: "We Offer Cost-Effective, Scalable Court Transcription",
            en: "We Offer Cost-Effective, Scalable Court Transcription",
            fr: "We Offer Cost-Effective, Scalable Court Transcription",
          },
          highlightWords: {
            default: ["Cost-Effective"],
            en: ["Cost-Effective"],
            fr: ["Cost-Effective"],
          },
          highlightedColor: "yellow",
          description: {
            default:
              "Large volumes of files might scare others or overwhelm other transcriptionists. However, LexTranscribe has scalable transcription solutions to transcribe large volumes of legal files accurately and methodically, saving you the headache of backlogs and increasing your margins.",
            en: "Large volumes of files might scare others or overwhelm other transcriptionists. However, LexTranscribe has scalable transcription solutions to transcribe large volumes of legal files accurately and methodically, saving you the headache of backlogs and increasing your margins.",
            fr: "Large volumes of files might scare others or overwhelm other transcriptionists. However, LexTranscribe has scalable transcription solutions to transcribe large volumes of legal files accurately and methodically, saving you the headache of backlogs and increasing your margins.",
          },
        },
      ],
    },
  ],
};
export const curtCtaData = {
  heading: {
    default: "Get a price quote for court transcription today.",
    en: "Get a price quote for court transcription today.",
    fr: "Get a price quote for court transcription today.",
  },
  text: {
    default: "CONTACT US",
    en: "CONTACT US",
    fr: "CONTACT US",
  },
  href: {
    default: "/contactus",
    en: "/contactus",
    fr: "/contactus",
  },
};
export const curtdata = {
  title: {
    default: "Court Transcriptionists Available In All 50 US States",
    en: "Court Transcriptionists Available In All 50 US States",
    fr: "Court Transcriptionists Available In All 50 US States",
  },
  highlightWords: {
    default: ["Court Transcriptionists"],
    en: ["Court Transcriptionists"],
    fr: ["Court Transcriptionists"],
  },
  highlightedColor: "yellow",
  description: {
    default:
      "We provide court-certified transcripts for law firms & legal institutions in all 50 US states. Our court transcribers have worked with US courts for many years, and they have expertise in US laws and regulations. Receive court-approved transcripts today.",
    en: "We provide court-certified transcripts for law firms & legal institutions in all 50 US states. Our court transcribers have worked with US courts for many years, and they have expertise in US laws and regulations. Receive court-approved transcripts today.",
    fr: "We provide court-certified transcripts for law firms & legal institutions in all 50 US states. Our court transcribers have worked with US courts for many years, and they have expertise in US laws and regulations. Receive court-approved transcripts today.",
  },
};
export const curtFrequentlyData = {
  title: {
    default: "Frequently Asked Questions",
    en: "Frequently Asked Questions",
    fr: "Frequently Asked Questions",
  },
  accordionItems: [
    {
      heading: {
        default: "What is a certified deposition transcript?",
        en: "What is a certified deposition transcript?",
        fr: "What is a certified deposition transcript?",
      },
      description: {
        default:
          "At LexTranscribe, you submit audio or video files of the court proceedings. If you don’t have a recording but have a trial or hearing coming up, contact us for more information about the next steps.<br/><br/> Once we receive your files, our transcriptionist listens to your recording from beginning to end and then transcribes. After several rounds of proofreading and quality checks, we deliver the transcript for your review.",
        en: "At LexTranscribe, you submit audio or video files of the court proceedings. If you don’t have a recording but have a trial or hearing coming up, contact us for more information about the next steps.<br/><br/> Once we receive your files, our transcriptionist listens to your recording from beginning to end and then transcribes. After several rounds of proofreading and quality checks, we deliver the transcript for your review.",
        fr: "At LexTranscribe, you submit audio or video files of the court proceedings. If you don’t have a recording but have a trial or hearing coming up, contact us for more information about the next steps.<br/><br/> Once we receive your files, our transcriptionist listens to your recording from beginning to end and then transcribes. After several rounds of proofreading and quality checks, we deliver the transcript for your review.",
      },
    },
    {
      heading: {
        default: "How long does it take to transcribe a court hearing?",
        en: "How long does it take to transcribe a court hearing?",
        fr: "How long does it take to transcribe a court hearing?",
      },
      description: {
        default:
          "It could take weeks for court reporters to transcribe a court hearing. However, with LexTranscribe, you can get your court transcripts in three simple steps. Choose our fast delivery option for urgent transcript requests. To learn more about our custom turnaround times, contact us today.",
        en: "It could take weeks for court reporters to transcribe a court hearing. However, with LexTranscribe, you can get your court transcripts in three simple steps. Choose our fast delivery option for urgent transcript requests. To learn more about our custom turnaround times, contact us today.",
        fr: "It could take weeks for court reporters to transcribe a court hearing. However, with LexTranscribe, you can get your court transcripts in three simple steps. Choose our fast delivery option for urgent transcript requests. To learn more about our custom turnaround times, contact us today.",
      },
    },
  ],
};
export const CurtFormData = {
  title: {
    default: "Ready to work with our court transcription team?",
    en: "Ready to work with our court transcription team?",
    fr: "Ready to work with our court transcription team?",
  },
  subtitle: {
    default: "*By submitting, you agree to LexTranscribe's Privacy Policy.",
    en: "*By submitting, you agree to LexTranscribe's Privacy Policy.",
    fr: "*By submitting, you agree to LexTranscribe's Privacy Policy.",
  },
  placeholder: {
    name: {
      default: "Name",
      en: "Name",
      fr: "Name",
    },
    email: {
      default: "Email Address",
      en: "Email Address",
      fr: "Email Address",
    },
  },
  btnText: {
    default: "SUBMIT",
    en: "SUBMIT",
    fr: "SUBMIT",
  },
};

export const Lawtitledata = {
  title: {
    default: "Law Enforcement Transcription Services",
    en: "Law Enforcement Transcription Services",
    fr: "Law Enforcement Transcription Services",
  },
  description: {
    default:
      "Your time is valuable. Don’t waste it writing reports all day. LexTranscribe offers fast, accurate law enforcement transcription services for police and investigative departments at local, state, and federal levels.<br/><br/> Use your skills where they’re needed most, and let our certified transcriptionists transform your audio & video into searchable, shareable texts.",
    en: "Your time is valuable. Don’t waste it writing reports all day. LexTranscribe offers fast, accurate law enforcement transcription services for police and investigative departments at local, state, and federal levels.<br/><br/> Use your skills where they’re needed most, and let our certified transcriptionists transform your audio & video into searchable, shareable texts.",
    fr: "Your time is valuable. Don’t waste it writing reports all day. LexTranscribe offers fast, accurate law enforcement transcription services for police and investigative departments at local, state, and federal levels.<br/><br/> Use your skills where they’re needed most, and let our certified transcriptionists transform your audio & video into searchable, shareable texts.",
  },
  btnText: {
    default: "GET STARTED",
    en: "GET STARTED",
    fr: "GET STARTED",
  },
  imgurl: {
    default: lawEnforcementBanner,
    en: lawEnforcementBanner,
    fr: lawEnforcementBanner,
  },
  sealDesktop: [
    {
      icon: "quality-guaranteed",
      text: "Guaranteed</br>Quality & Accuracy",
    },
    {
      icon: "expert-human",
      text: "Expert Human</br>Transcriptionists",
    },
    {
      icon: "fast-delivery-two",
      text: "Fast Delivery",
    },
    {
      icon: "secure",
      text: "Secure &</br>Confidential",
    },
  ],
  sealMobile: [
    {
      icon: "expert-human",
      text: "Expert Human</br>Transcriptionists",
    },
    {
      icon: "rating",
      text: "4.8 out of 5</br>Aggregate Rating",
    },
  ],
};

export const LawpageData2 = {
  title: {
    default:
      "Your Law Enforcement Transcriptionist Lightens Your Department’s Workload",
    en: "Your Law Enforcement Transcriptionist Lightens Your Department’s Workload",
    fr: "Your Law Enforcement Transcriptionist Lightens Your Department’s Workload",
  },
  highlightWords: {
    default: ["Law Enforcement"],
    en: ["Law Enforcement"],
    fr: ["Law Enforcement"],
  },
  highlightedColor: "yellow",
  subtitle: {
    default:
      "Law enforcement agencies are overburdened, underfunded, and seriously understaffed. We’ll connect you with a law enforcement transcriptionist who can lighten your heavy burden.<br Boost your department’s morale and reduce officer burnout. Get accurate transcription to eliminate the mounds of paperwork tying them to their desks.",
    en: "Law enforcement agencies are overburdened, underfunded, and seriously understaffed. We’ll connect you with a law enforcement transcriptionist who can lighten your heavy burden.<br Boost your department’s morale and reduce officer burnout. Get accurate transcription to eliminate the mounds of paperwork tying them to their desks.",
    fr: "Law enforcement agencies are overburdened, underfunded, and seriously understaffed. We’ll connect you with a law enforcement transcriptionist who can lighten your heavy burden.<br Boost your department’s morale and reduce officer burnout. Get accurate transcription to eliminate the mounds of paperwork tying them to their desks.",
  },
};
export const LawpageTwoColGridWithOrderData = {
  title: {
    default: "Why Choose Our Law Enforcement Transcription Services?",
    en: "Why Choose Our Law Enforcement Transcription Services?",
    fr: "Why Choose Our Law Enforcement Transcription Services?",
  },
  highlightWords: {
    default: [" "],
    en: [" "],
    fr: [" "],
  },
  highlightedColor: "yellow",
  subTitle: {
    default:
      "Very few transcription companies can produce transcripts that meet law enforcement deadlines & standards. But LexTranscribe understands how critical your department’s reporting deadlines are to the flow of the criminal justice system. Our team delivers fast law enforcement transcription while maintaining the highest quality - 100% Guaranteed.",
    en: "Very few transcription companies can produce transcripts that meet law enforcement deadlines & standards. But LexTranscribe understands how critical your department’s reporting deadlines are to the flow of the criminal justice system. Our team delivers fast law enforcement transcription while maintaining the highest quality - 100% Guaranteed.",
    fr: "Very few transcription companies can produce transcripts that meet law enforcement deadlines & standards. But LexTranscribe understands how critical your department’s reporting deadlines are to the flow of the criminal justice system. Our team delivers fast law enforcement transcription while maintaining the highest quality - 100% Guaranteed.",
  },
  items: [
    {
      image: {
        default: whyImg1,
        en: whyImg1,
        fr: whyImg1,
      },
      mainData: [
        {
          title: {
            default:
              "Select A Law Enforcement Transcriptionist Who Understands Your Needs",
            en: "Select A Law Enforcement Transcriptionist Who Understands Your Needs",
            fr: "Select A Law Enforcement Transcriptionist Who Understands Your Needs",
          },
          highlightWords: {
            default: ["Law Enforcement Transcriptionist"],
            en: ["Law Enforcement Transcriptionist"],
            fr: ["Law Enforcement Transcriptionist"],
          },
          highlightedColor: "yellow",
          description: {
            default:
              "Computers can’t decipher complex human problems. However, our certified transcriptionists are native speakers. We have experience in police procedures and law enforcement regulations, and we consistently produce transcripts on time according to your specifications.",
            en: "Computers can’t decipher complex human problems. However, our certified transcriptionists are native speakers. We have experience in police procedures and law enforcement regulations, and we consistently produce transcripts on time according to your specifications.",
            fr: "Computers can’t decipher complex human problems. However, our certified transcriptionists are native speakers. We have experience in police procedures and law enforcement regulations, and we consistently produce transcripts on time according to your specifications.",
          },
        },
        {
          title: {
            default: "Transcriptions for Law Enforcement In Custom Formats",
            en: "Transcriptions for Law Enforcement In Custom Formats",
            fr: "Transcriptions for Law Enforcement In Custom Formats",
          },
          highlightWords: {
            default: ["Custom Formats"],
            en: ["Custom Formats"],
            fr: ["Custom Formats"],
          },
          highlightedColor: "yellow",
          description: {
            default:
              "We can deliver the transcript according to your department’s format & instructions. We transcribe dictated police reports, interrogations, bodycam footage, police vehicle audio, and 911 calls in any digital file format. We offer other types of law enforcement transcription as well, including but not limited to:",
            en: "We can deliver the transcript according to your department’s format & instructions. We transcribe dictated police reports, interrogations, bodycam footage, police vehicle audio, and 911 calls in any digital file format. We offer other types of law enforcement transcription as well, including but not limited to:",
            fr: "We can deliver the transcript according to your department’s format & instructions. We transcribe dictated police reports, interrogations, bodycam footage, police vehicle audio, and 911 calls in any digital file format. We offer other types of law enforcement transcription as well, including but not limited to:",
          },
          list: [
            {
              text: {
                default: "Victim Interviews",
                en: "Victim Interviews",
                fr: "Victim Interviews",
              },
            },
            {
              text: {
                default: "Wiretaps and Surveillance",
                en: "Wiretaps and Surveillance",
                fr: "Wiretaps and Surveillance",
              },
            },
            {
              text: {
                default: "Witness Interviews",
                en: "Witness Interviews",
                fr: "Witness Interviews",
              },
            },
            {
              text: {
                default: "Letters & Memos",
                en: "Letters & Memos",
                fr: "Letters & Memos",
              },
            },
            {
              text: {
                default: "Fire Reports",
                en: "Fire Reports",
                fr: "Fire Reports",
              },
            },
            {
              text: {
                default: "Staff and Department Meetings",
                en: "Staff and Department Meetings",
                fr: "Staff and Department Meetings",
              },
            },
          ],
        },
      ],
    },
    {
      image: {
        default: whyImg2,
        en: whyImg2,
        fr: whyImg2,
      },

      mainData: [
        {
          title: {
            default:
              "Accurate Police Transcription Held To The Highest Quality Standards",
            en: "Accurate Police Transcription Held To The Highest Quality Standards",
            fr: "Accurate Police Transcription Held To The Highest Quality Standards",
          },
          highlightWords: {
            default: ["Accurate"],
            en: ["Accurate"],
            fr: ["Accurate"],
          },
          highlightedColor: "yellow",
          description: {
            default:
              "With citizens’ freedom at stake, you don’t want to select the wrong transcriber. LexTranscribe holds our police transcription service to the highest standards in the industry. Your police transcripts go through multiple proofreading rounds and editing sessions to ensure accuracy.",
            en: "With citizens’ freedom at stake, you don’t want to select the wrong transcriber. LexTranscribe holds our police transcription service to the highest standards in the industry. Your police transcripts go through multiple proofreading rounds and editing sessions to ensure accuracy.",
            fr: "With citizens’ freedom at stake, you don’t want to select the wrong transcriber. LexTranscribe holds our police transcription service to the highest standards in the industry. Your police transcripts go through multiple proofreading rounds and editing sessions to ensure accuracy.",
          },
        },
        {
          title: {
            default: "Strict Data Security and Confidentiality Protocols",
            en: "Strict Data Security and Confidentiality Protocols",
            fr: "Strict Data Security and Confidentiality Protocols",
          },
          highlightWords: {
            default: ["Strict"],
            en: ["Strict"],
            fr: ["Strict"],
          },
          highlightedColor: "yellow",
          description: {
            default:
              "Hackers target your privileged information causing serious concerns for you & your department. We protect your data security with SSL encryption to transmit & process your files. We also implement strict security protocols to guard your confidentiality.",
            en: "Hackers target your privileged information causing serious concerns for you & your department. We protect your data security with SSL encryption to transmit & process your files. We also implement strict security protocols to guard your confidentiality.",
            fr: "Hackers target your privileged information causing serious concerns for you & your department. We protect your data security with SSL encryption to transmit & process your files. We also implement strict security protocols to guard your confidentiality.",
          },
        },
      ],
    },
    {
      image: {
        default: whyImg3,
        en: whyImg3,
        fr: whyImg3,
      },

      mainData: [
        {
          title: {
            default:
              "Fast Turnaround Times Because Law Enforcement Operates Around The Clock",
            en: "Fast Turnaround Times Because Law Enforcement Operates Around The Clock",
            fr: "Fast Turnaround Times Because Law Enforcement Operates Around The Clock",
          },
          highlightWords: {
            default: ["Fast Turnaround"],
            en: ["Fast Turnaround"],
            fr: ["Fast Turnaround"],
          },
          highlightedColor: "yellow",
          description: {
            default:
              "Prosecutors, supervisors, jurors, & judges are waiting on your report so the criminal system can move forward. At LexTranscribe, we won’t keep you waiting. Our transcriptionists deliver fast, accurate law enforcement transcription well before your deadline.",
            en: "Prosecutors, supervisors, jurors, & judges are waiting on your report so the criminal system can move forward. At LexTranscribe, we won’t keep you waiting. Our transcriptionists deliver fast, accurate law enforcement transcription well before your deadline.",
            fr: "Prosecutors, supervisors, jurors, & judges are waiting on your report so the criminal system can move forward. At LexTranscribe, we won’t keep you waiting. Our transcriptionists deliver fast, accurate law enforcement transcription well before your deadline.",
          },
        },
        {
          title: {
            default:
              "Scalable Solutions For Law Enforcement Audio & Video Files",
            en: "Scalable Solutions For Law Enforcement Audio & Video Files",
            fr: "Scalable Solutions For Law Enforcement Audio & Video Files",
          },
          highlightWords: {
            default: ["Scalable Solutions"],
            en: ["Scalable Solutions"],
            fr: ["Scalable Solutions"],
          },
          highlightedColor: "yellow",
          description: {
            default:
              "Are large volumes of reports and body cam footage taking up space on your hard drive? We can help you get organized with scalable transcription solutions. Let our world-class team transcribe your audio & video files today.",
            en: "Are large volumes of reports and body cam footage taking up space on your hard drive? We can help you get organized with scalable transcription solutions. Let our world-class team transcribe your audio & video files today.",
            fr: "Are large volumes of reports and body cam footage taking up space on your hard drive? We can help you get organized with scalable transcription solutions. Let our world-class team transcribe your audio & video files today.",
          },
        },
      ],
    },
  ],
};
export const LawCtaData = {
  heading: {
    default: "Get access to law enforcement transcription today.",
    en: "Get access to law enforcement transcription today.",
    fr: "Get access to law enforcement transcription today.",
  },
  text: {
    default: "CONTACT US",
    en: "CONTACT US",
    fr: "CONTACT US",
  },
  href: {
    default: "/contactus",
    en: "/contactus",
    fr: "/contactus",
  },
};
export const LawEnforcementdata = {
  title: {
    default: "Certified US Law Enforcement Transcriber",
    en: "Certified US Law Enforcement Transcriber",
    fr: "Certified US Law Enforcement Transcriber",
  },
  highlightWords: {
    default: ["Law Enforcement Transcriber"],
    en: ["Law Enforcement Transcriber"],
    fr: ["Law Enforcement Transcriber"],
  },
  highlightedColor: "yellow",
  description: {
    default:
      "Looking for police transcribers near you? We offer certified police transcripts for departments in all 50 states, from Pennsylvania to California. Our law enforcement transcribers have expertise in local, state, and federal police procedures, as well as US laws and regulations. Get court-approved transcripts today.",
    en: "Looking for police transcribers near you? We offer certified police transcripts for departments in all 50 states, from Pennsylvania to California. Our law enforcement transcribers have expertise in local, state, and federal police procedures, as well as US laws and regulations. Get court-approved transcripts today.",
    fr: "Looking for police transcribers near you? We offer certified police transcripts for departments in all 50 states, from Pennsylvania to California. Our law enforcement transcribers have expertise in local, state, and federal police procedures, as well as US laws and regulations. Get court-approved transcripts today.",
  },
};
export const LawFrequentlyData = {
  title: {
    default: "Frequently Asked Questions",
    en: "Frequently Asked Questions",
    fr: "Frequently Asked Questions",
  },
  accordionItems: [
    {
      heading: {
        default: "What is a law enforcement transcriptionist?",
        en: "What is a law enforcement transcriptionist?",
        fr: "What is a law enforcement transcriptionist?",
      },
      description: {
        default:
          "A law enforcement transcriptionist transforms speech from audio & video into text. We provide a verbatim record of witness statements, victim interviews, interrogations, jail phone calls, body cam footage, wiretaps, and much more. Our law enforcement transcriptionists are fully certified.",
        en: "A law enforcement transcriptionist transforms speech from audio & video into text. We provide a verbatim record of witness statements, victim interviews, interrogations, jail phone calls, body cam footage, wiretaps, and much more. Our law enforcement transcriptionists are fully certified.",
        fr: "A law enforcement transcriptionist transforms speech from audio & video into text. We provide a verbatim record of witness statements, victim interviews, interrogations, jail phone calls, body cam footage, wiretaps, and much more. Our law enforcement transcriptionists are fully certified.",
      },
    },
    {
      heading: {
        default: "Do you provide remote law enforcement transcription?",
        en: "Do you provide remote law enforcement transcription?",
        fr: "Do you provide remote law enforcement transcription?",
      },
      description: {
        default:
          "Yes, we provide remote law enforcement transcription. Simply send us your audio or video files in any digital format and any special instructions for our transcribers. We’ll have your transcripts ready according to your schedule.",
        en: "Yes, we provide remote law enforcement transcription. Simply send us your audio or video files in any digital format and any special instructions for our transcribers. We’ll have your transcripts ready according to your schedule.",
        fr: "Yes, we provide remote law enforcement transcription. Simply send us your audio or video files in any digital format and any special instructions for our transcribers. We’ll have your transcripts ready according to your schedule.",
      },
    },
  ],
};
export const LawFormData = {
  title: {
    default: "Get fast, accurate police<br/> transcription now.",
    en: "Get fast, accurate police<br/> transcription now.",
    fr: "Get fast, accurate police<br/> transcription now.",
  },
  subtitle: {
    default: "*By submitting, you agree to LexTranscribe's Privacy Policy.",
    en: "*By submitting, you agree to LexTranscribe's Privacy Policy.",
    fr: "*By submitting, you agree to LexTranscribe's Privacy Policy.",
  },
  placeholder: {
    name: {
      default: "Name",
      en: "Name",
      fr: "Name",
    },
    email: {
      default: "Email Address",
      en: "Email Address",
      fr: "Email Address",
    },
  },
  btnText: {
    default: "SUBMIT",
    en: "SUBMIT",
    fr: "SUBMIT",
  },
};

export const whyChooseUsData = {
  dataType: 1,
  title: "Why Choose Our<br> Deposition Transcription Agency?",
  highlightWords: [],
  highlightedColor: "yellow",
  description:
    "The outcome of your case depends on which deposition transcription agency you choose. LexTranscribe understands how critical the accuracy of this transcript is to your success. We’re committed to providing the high-quality legal transcript you need.",
  items: [
    {
      image:
        "https://tomedes.gumlet.io/assets/legal-transcription/banner/banner.webp",
      mainData: [
        {
          title: "You Deserve A Certified Deposition Transcriptionist",
          highlightWords: ["Certified"],
          highlightedColor: "yellow",
          description:
            "Don’t settle for mediocre deposition transcription services. They’ll only let you down at the last minute. Our certified deposition transcriptionists have years of experience & specialized legal knowledge. Get accurate transcriptions of your deposition video now.",
          list: null,
        },
        {
          title: "We Transcribe Depositions In Many<br>File Formats",
          highlightWords: ["File Formats"],
          highlightedColor: "yellow",
          description:
            "We'll deliver your deposition transcripts in standard or custom format according to your requirements. For your convenience, we transcribe traditional or remote depositions in 50+ audio and video file types including but not limited to:",
          list: [
            {
              text: "MP3 & MP4",
            },
            {
              text: "Windows Media Audio - WMA",
            },
            {
              text: "Waveform Audio - WAV",
            },
            {
              text: "Audio Interchange File - AIFF",
            },
            {
              text: "Digital Speech<br>Standard - DSS",
            },
            {
              text: "Quick Time Movie - MOV",
            },
          ],
        },
      ],
    },
    {
      image:
        "https://tomedes.gumlet.io/assets/legal-transcription/banner/banner.webp",

      mainData: [
        {
          title: "We Support Your Success With Postproduction Services",
          highlightWords: ["Support"],
          highlightedColor: "yellow",
          description:
            "Far too often, companies leave clients to fend for themselves. However, we provide postproduction services one year after your transcription, such as subtitles & captions for the deposition video. We are dedicated to helping you succeed.",
          list: null,
        },
        {
          title: "We Safeguard Your Data Security & Confidentiality",
          highlightWords: ["Data Security"],
          highlightedColor: "yellow",
          description:
            "Viruses, malware, and hackers put your data and confidentiality at risk. We understand security and confidentiality are crucial in the legal sector. LexTranscibe features SSL encryption and strict security protocols to transmit, process, and store your sensitive files.",
          list: null,
        },
      ],
    },
  ],
};

export const bannerSealData = {
  desktop: [
    {
      icon: "quality-guaranteed",
      text: "Guaranteed</br>Quality & Accuracy",
    },
    {
      icon: "expert-human",
      text: "Expert Human</br>Transcriptionists",
    },
    {
      icon: "fast-delivery-two",
      text: "Fast Delivery",
    },
    {
      icon: "secure",
      text: "Secure &</br>Confidential",
    },
  ],
  mobile: [
    {
      icon: "expert-human",
      text: "Expert Human</br>Transcriptionists",
    },
    {
      icon: "rating",
      text: "4.8 out of 5</br>Aggregate Rating",
    },
  ],
};
